/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1EtsyInfoPacks, updateTKT1EtsyInfoPack, createTKT1EtsyInfoPack, getTKT1BankBrands, getTKT1TrustedPersonInfos, getTKT1C3DInfos, getTKT1ScanPersons, getTKT1TrustedBankAccounts, getTKT1TrustedBankVisas, getTKT1DevicePacks, getTKT1TrustedStories, getTKT1Sims, getTKT1Emails } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal,
  Toast,
  ToastContainer,
  Tabs,
  Tab
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt, FaPlus, FaCog, FaChevronLeft, FaChevronRight, FaStickyNote, FaQrcode } from 'react-icons/fa';
import { generateMRZ_TD1 } from '../utils/mrzGenerator';
import IframeModal from '../components/IframeModal/IframeModal';
import Select from 'react-select';
import { QRCodeSVG } from 'qrcode.react';

class TKT1EtsyInfoPack extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 20,
    sortBy: 'created_at',
    sortOrder: -1,
    search: '',
    status: ''
  }

  initShowColumns = {
    mid: true,
    shop_name: true,
    seller_name: true,
    trusted_story_mid: true,
    trusted_person_mid: true,
    valid_c3d_number: true,
    scan_person_mid: true,
    trusted_bank_acc_mid: true,
    trusted_bank_visa_mid: true,
    device_pack_location_id: true,
    sim_mid: true,
    seller_address: true,
    email1_mid: true,
    email2_mid: true,
    buyer_registration_date: true,
    seller_registration_date: true,
    note: true,
    status: true,
    is_active: true,
    created_at: false
  }

  initColumnWidths = {
    stt: 60,
    mid: 120,
    shop_name: 150,
    seller_name: 150,
    trusted_story_mid: 150,
    trusted_person_mid: 150,
    valid_c3d_number: 120,
    scan_person_mid: 150,
    trusted_bank_acc_mid: 150,
    trusted_bank_visa_mid: 150,
    device_pack_location_id: 150,
    sim_mid: 120,
    seller_address: 200,
    email1_mid: 120,
    email2_mid: 120,
    buyer_registration_date: 150,
    seller_registration_date: 150,
    note: 200,
    status: 120,
    is_active: 100,
    created_at: 150,
    actions: 100
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      columnWidths: this.initColumnWidths,
      loading: false,
      showConfigModal: false,
      showEditModal: false,
      showCreateModal: false,
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: '',
      selectedEtsyInfoPack: null,
      isEditMode: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      trustedPersons: [],
      c3dInfos: [],
      trustedBankAccounts: [],
      trustedBankVisas: [],
      trustedStories: [],
      scanPersons: [],
      devicePacks: [],
      sims: [],
      emails: [],
      bankBrands: [],
      // Info modals
      showTrustedPersonInfoModal: false,
      showC3DInfoModal: false,
      showScanPersonInfoModal: false,
      showBankAccountInfoModal: false,
      showBankVisaInfoModal: false,
      showDevicePackInfoModal: false,
      showStoryInfoModal: false,
      showSetupEtsyInfoModal: false,
      showSimInfoModal: false,
      selectedSimInfo: null,
      showEmail1InfoModal: false,
      showEmail2InfoModal: false,
      selectedEmailInfo: null,
      selectedInfoData: null,
      // Photo modal states
      showPhotosModal: false,
      selectedPhotos: [],
      currentPhotoIndex: 0,
      showNoteModal: false,
      selectedNoteData: null,
      isResizing: false,
      resizingColumn: null,
      resizeStartX: null,
      resizeStartWidth: null,
      editFormData: {
        trusted_person_mid: '',
        valid_c3d_number: '',
        scan_person_mid: '',
        trusted_bank_acc_mid: '',
        trusted_bank_visa_mid: '',
        device_pack_location_id: '',
        trusted_story_mid: '',
        sim_mid: '',
        seller_address: '',
        email1_mid: '',
        email2_mid: '',
        buyer_registration_date: '',
        seller_registration_date: '',
        note: '',
        status: 'active',
        metadata: {},
        is_active: true
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Etsy Info Pack';
    document.addEventListener('keydown', this.handleKeyDown);
    // Add mouse event listeners for column resizing
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      const queryObject = queryString.parse(queryStringFromUrl);
      
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      const viewConfig = JSON.parse(localStorage.getItem('TKT1EtsyInfoPack_ViewConfig'));
      const columnWidths = JSON.parse(localStorage.getItem('TKT1EtsyInfoPack_ColumnWidths'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        },
        columnWidths: {
          ...this.initColumnWidths,
          ...(columnWidths || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1EtsyInfoPacks(apiQuery);
        this.loadDropdownData();
      })
    } else {
      var query = JSON.parse(localStorage.getItem('tkt1_etsy_info_pack_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1EtsyInfoPack_ViewConfig'));
      var columnWidths = JSON.parse(localStorage.getItem('TKT1EtsyInfoPack_ColumnWidths'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1EtsyInfoPacks(apiQuery);
          this.loadDropdownData();
          this.loadBankBrands();
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1EtsyInfoPacks(apiQuery);
          this.loadDropdownData();
          this.loadBankBrands();
        })
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    // Remove mouse event listeners
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  loadDropdownData = async () => {
    try {
      // Load all dropdown data
      const query = { currentPage: 1, itemsPerPage: 1000, sortBy: 'MID', sortOrder: 1 };
      const emailQuery = { currentPage: 1, itemsPerPage: 1000, sortBy: 'email', sortOrder: 1 };
      const bankBrandQuery = { currentPage: 1, itemsPerPage: 100, sortBy: 'bank_name', sortOrder: 1 };
      await Promise.all([
        this.props.getTKT1TrustedPersonInfos(query),
        this.props.getTKT1ScanPersons(query),
        this.props.getTKT1DevicePacks(query),
        this.props.getTKT1TrustedStories(query),
        this.props.getTKT1Sims(query),
        this.props.getTKT1Emails(emailQuery),
        this.props.getTKT1BankBrands(bankBrandQuery)
      ]);
    } catch (error) {
      console.error('Error loading dropdown data:', error);
    }
  }

  loadBankBrands = async () => {
    try {
      const query = { currentPage: 1, itemsPerPage: 100, sortBy: 'bank_name', sortOrder: 1 };
      await this.props.getTKT1BankBrands(query);
    } catch (error) {
      console.error('Error loading bank brands:', error);
    }
  }

  loadDependentData = async (trustedPersonMid) => {
    try {
      if (!trustedPersonMid) return;
      
      const query = { currentPage: 1, itemsPerPage: 1000, sortBy: 'MID', sortOrder: 1 };
      
      // Load C3D Infos filtered by ref_trusted_person_mid
      const c3dQuery = { ...query, ref_trusted_person_mid: trustedPersonMid };
      await this.props.getTKT1C3DInfos(c3dQuery);
      
      // Load Trusted Bank Accounts filtered by trust_person_mid
      const bankAccountQuery = { ...query, trust_person_mid: trustedPersonMid };
      await this.props.getTKT1TrustedBankAccounts(bankAccountQuery);
      
      // Load Trusted Bank Visas filtered by trust_person_mid
      const bankVisaQuery = { ...query, trust_person_mid: trustedPersonMid };
      await this.props.getTKT1TrustedBankVisas(bankVisaQuery);
    } catch (error) {
      console.error('Error loading dependent data:', error);
    }
  }

  getSwiftCodeFromBankBrand = (bankShortName) => {
    if (!bankShortName || !this.props.bankBrands) return '';
    
    const bankBrand = this.props.bankBrands.find(brand => 
      brand.short_name === bankShortName || 
      brand.bank_name === bankShortName ||
      brand.bank_code === bankShortName
    );
    
    return bankBrand?.swift_code || '';
  }

  getBankInfoFromBankBrand = (bankShortName) => {
    if (!bankShortName || !this.props.bankBrands) return null;
    
    const bankBrand = this.props.bankBrands.find(brand => 
      brand.short_name === bankShortName || 
      brand.bank_name === bankShortName ||
      brand.bank_code === bankShortName ||
      brand.vietnamese_name === bankShortName ||
      brand.english_name === bankShortName
    );
    
    return bankBrand ? {
      swift_code: bankBrand.swift_code,
      bank_name: bankBrand.bank_name,
      english_name: bankBrand.english_name,
      vietnamese_name: bankBrand.vietnamese_name
    } : null;
  }

  showToast = (message, type = 'success') => {
    this.setState({
      showToast: true,
      toastMessage: message,
      toastType: type
    });
    
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
      this.showToast('Đã copy vào clipboard!', 'success');
    }).catch(err => {
      console.error('Failed to copy: ', err);
      this.showToast('Lỗi khi copy!', 'error');
    });
  }

  // Format date to DD/MM/YYYY, handling both ISO strings and DD/MM/YYYY strings
  formatDate = (dateString) => {
    if (!dateString) return '-';
    
    // If already in DD/MM/YYYY format, return as is
    if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      return dateString;
    }
    
    // Try to parse as ISO date or other formats
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString; // Return original if can't parse
      }
      
      // Use toLocaleDateString with timezone option to get correct local date
      return date.toLocaleDateString('en-GB', {
        timeZone: 'Asia/Ho_Chi_Minh'
      });
    } catch (error) {
      return dateString; // Return original if error
    }
  }

  // Generate QR code data for C3D info
  generateQRData = (c3dInfo) => {
    if (!c3dInfo) return '';

    const formatDate = (dateString) => {
      if (!dateString) return '';
      
      // Handle different date formats
      if (dateString.includes('/')) {
        // Format: "29/07/1997" -> "29071997"
        return dateString.replace(/\//g, '');
      } else {
        // Format: ISO string -> "ddmmyyyy"
        try {
          const date = new Date(dateString);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear().toString();
          return `${day}${month}${year}`;
        } catch (error) {
          console.error('Error formatting date:', error);
          return '';
        }
      }
    };

    const formatGender = (gender) => {
      if (!gender) return '';
      switch (gender.toUpperCase()) {
        case 'MALE':
          return 'Nam';
        case 'FEMALE':
          return 'Nữ';
        default:
          return gender;
      }
    };

    const c3d_number = c3dInfo.c3d_number || '';
    const cmt_number = c3dInfo.cmt_number || '';
    const full_name = c3dInfo.full_name || '';
    const dob = formatDate(c3dInfo.c3d_dob);
    const sex = formatGender(c3dInfo.c3d_sex);
    const place_of_origin = c3dInfo.c3d_place_of_origin || '';
    const issue_date = formatDate(c3dInfo.c3d_issue_date);

    const qrData = `${c3d_number}|${cmt_number}|${full_name}|${dob}|${sex}|${place_of_origin}|${issue_date}||||`;
    console.log('Generated QR Data:', qrData); // Debug log
    return qrData;
  }

  // Generate MRZ TD1 (3x30) for C3D info using utility function
  generateMRZ = (c3dInfo) => {
    if (!c3dInfo || !c3dInfo.c3d_number) {
      console.log('MRZ Error: Missing c3dInfo or c3d_number');
      return null;
    }

    try {
      const cccd12 = c3dInfo.c3d_number;
      const name = c3dInfo.full_name || '';
      const dob = c3dInfo.c3d_dob || '';
      const sex = c3dInfo.c3d_sex === 'FEMALE' ? 'F' : 'M';
      const expiry = c3dInfo.c3d_expired_date || '';
      const issuingCountry = 'VNM';

      console.log('MRZ Input Data:', { cccd12, name, dob, sex, expiry });

      const mrz = generateMRZ_TD1({
        cccd12,
        name,
        dob,
        sex,
        expiry,
        issuingCountry
      });

      console.log('MRZ Generated Successfully:', mrz);
      return mrz;
    } catch (error) {
      console.error('Error generating MRZ:', error);
      console.error('C3D Info:', c3dInfo);
      return null;
    }
  }

  // Download QR code as PNG with transparent background
  downloadQRAsPNG = () => {
    const qrContainer = document.getElementById('qr-code-container');
    const svgElement = qrContainer?.querySelector('svg');
    
    if (!svgElement) {
      this.showToast('Không tìm thấy QR code để download!', 'error');
      return;
    }

    try {
      // Clone the SVG element to modify it
      const clonedSvg = svgElement.cloneNode(true);
      
      // Remove any background fill or set it to transparent
      const rects = clonedSvg.querySelectorAll('rect');
      rects.forEach(rect => {
        if (rect.getAttribute('fill') === '#ffffff' || rect.getAttribute('fill') === 'white') {
          rect.setAttribute('fill', 'transparent');
        }
      });
      
      // Set SVG background to transparent
      clonedSvg.setAttribute('style', 'background: transparent;');
      clonedSvg.style.backgroundColor = 'transparent';
      
      // Get SVG data
      const svgData = new XMLSerializer().serializeToString(clonedSvg);
      
      // Create canvas with transparent background
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d', { alpha: true });
      
      // Set canvas size (higher resolution)
      const size = 300; // Higher resolution for better quality
      canvas.width = size;
      canvas.height = size;
      
      // Ensure transparent background
      ctx.clearRect(0, 0, size, size);
      ctx.fillStyle = 'transparent';
      ctx.fillRect(0, 0, size, size);
      
      // Create image from SVG
      const img = new Image();
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(svgBlob);
      
      img.onload = () => {
        // Draw image on canvas with transparent background
        ctx.drawImage(img, 0, 0, size, size);
        
        // Convert to PNG and download
        canvas.toBlob((blob) => {
          const link = document.createElement('a');
          const fileName = `QR_${this.state.selectedInfoData.c3d_number || 'C3D'}_${new Date().getTime()}.png`;
          
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          // Clean up
          URL.revokeObjectURL(url);
          URL.revokeObjectURL(link.href);
          
          this.showToast('Đã download QR code thành công!', 'success');
        }, 'image/png');
      };
      
      img.onerror = () => {
        this.showToast('Lỗi khi tạo QR code PNG!', 'error');
        URL.revokeObjectURL(url);
      };
      
      img.src = url;
      
    } catch (error) {
      console.error('Error downloading QR code:', error);
      this.showToast('Lỗi khi download QR code!', 'error');
    }
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim(),
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery)
    this.props.getTKT1EtsyInfoPacks(apiQuery);
    localStorage.setItem('tkt1_etsy_info_pack_query', JSON.stringify(trimmedQuery));
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  prepareApiQuery = (query) => {
    const { showColumns, search, status, show_sidebar, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    return apiQuery;
  }

  updateUrl = (query) => {
    const { history } = this.props;
    const { showColumns, show_sidebar, ...urlQuery } = query;
    
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1-etsy/etsy-info-pack',
      search: queryStr,
    });
  }

  handleCreateClick = () => {
    this.setState({
      showCreateModal: true,
      selectedEtsyInfoPack: null,
      isEditMode: false,
      editFormData: {
        trusted_person_mid: '',
        valid_c3d_number: '',
        scan_person_mid: '',
        trusted_bank_acc_mid: '',
        trusted_bank_visa_mid: '',
        device_pack_location_id: '',
        trusted_story_mid: '',
        sim_mid: '',
        seller_address: '',
        email1_mid: '',
        email2_mid: '',
        buyer_registration_date: '',
        seller_registration_date: '',
        note: '',
        status: 'active',
        metadata: {},
        is_active: true
      }
    });
  }

  handleFormChange = (field, value) => {
    this.setState(prevState => ({
      editFormData: {
        ...prevState.editFormData,
        [field]: value
      }
    }));

    // If Trust Person MID changes, reset related dropdowns and load dependent data
    if (field === 'trusted_person_mid') {
      this.setState(prevState => ({
        editFormData: {
          ...prevState.editFormData,
          [field]: value,
          valid_c3d_number: '', // Reset Valid C3D Number
          trusted_bank_acc_mid: '', // Reset Bank Account MID
          trusted_bank_visa_mid: '', // Reset Bank Visa MID
          // Note: trusted_story_mid is not reset as it's not related to Trust Person MID
        }
      }));
      
      // Load dependent data for the selected Trust Person MID
      if (value) {
        this.loadDependentData(value);
      }
    }
  }


  // Extract tax cities from DN_tax_infos and TNCN_tax_infos (similar to TKT1C3DInfo.js)
  getTaxCities = (info) => {
    if (!info) return '';
    
    const cities = new Set();
    
    // Extract cities from DN_tax_infos
    if (info.DN_tax_infos && Array.isArray(info.DN_tax_infos)) {
      info.DN_tax_infos.forEach(taxInfo => {
        if (taxInfo.city && taxInfo.city.trim()) {
          cities.add(taxInfo.city.trim());
        }
      });
    }
    
    // Extract cities from TNCN_tax_infos
    if (info.TNCN_tax_infos && Array.isArray(info.TNCN_tax_infos)) {
      info.TNCN_tax_infos.forEach(taxInfo => {
        if (taxInfo.city && taxInfo.city.trim()) {
          cities.add(taxInfo.city.trim());
        }
      });
    }
    
    return cities.size > 0 ? Array.from(cities).join(' | ') : '';
  }

  // Filter C3D options based on selected Trust Person MID
  getFilteredC3DOptions = () => {
    const { c3dInfos } = this.props;
    const { editFormData } = this.state;
    
    if (!c3dInfos || !Array.isArray(c3dInfos)) return [];
    
    // If no Trust Person MID selected, return empty array (dropdown will be disabled)
    if (!editFormData.trusted_person_mid) {
      return [];
    }
    
    // Filter C3D options by Trust Person MID
    return c3dInfos
      .filter(c3d => c3d.ref_trusted_person_mid === editFormData.trusted_person_mid)
      .map((c3d) => {
        const taxCities = this.getTaxCities(c3d);
        const assignedInfo = c3d.ref_etsy_info_pack_mid ? ` [Đã gán: ${c3d.ref_etsy_info_pack_mid}]` : '';
        return {
          value: c3d.c3d_number,
          label: `${c3d.c3d_number} - ${c3d.full_name}${c3d.full_name_english ? ` (${c3d.full_name_english})` : ''}${taxCities ? ` - ${taxCities}` : ''}${assignedInfo}`
        };
      });
  }

  // Filter Bank Account options based on selected Trust Person MID
  getFilteredBankAccountOptions = () => {
    const { trustedBankAccounts } = this.props;
    const { editFormData } = this.state;
    
    if (!trustedBankAccounts || !Array.isArray(trustedBankAccounts)) return [];
    
    // If no Trust Person MID selected, return empty array (dropdown will be disabled)
    if (!editFormData.trusted_person_mid) {
      return [];
    }
    
    // Filter Bank Account options by Trust Person MID
    return trustedBankAccounts
      .filter(account => account.trust_person_mid === editFormData.trusted_person_mid)
      .map((account) => {
        const assignedInfo = account.ref_etsy_info_pack_mid ? ` [Đã gán: ${account.ref_etsy_info_pack_mid}]` : '';
        return {
          value: account.MID,
          label: `${account.MID} - ${account.trusted_person_info?.full_name || account.bank_short_name}${assignedInfo}`
        };
      });
  }

  // Filter Bank Visa options based on selected Trust Person MID
  getFilteredBankVisaOptions = () => {
    const { trustedBankVisas } = this.props;
    const { editFormData } = this.state;
    
    if (!trustedBankVisas || !Array.isArray(trustedBankVisas)) return [];
    
    // If no Trust Person MID selected, return empty array (dropdown will be disabled)
    if (!editFormData.trusted_person_mid) {
      return [];
    }
    
    // Filter Bank Visa options by Trust Person MID
    return trustedBankVisas
      .filter(visa => visa.trust_person_mid === editFormData.trusted_person_mid)
      .map((visa) => {
        const assignedInfo = visa.ref_etsy_info_pack_mid ? ` [Đã gán: ${visa.ref_etsy_info_pack_mid}]` : '';
        return {
          value: visa.MID,
          label: `${visa.MID} - ${visa.trusted_person_info?.full_name || visa.bank_short_name}${assignedInfo}`
        };
      });
  }

  // Get all Story options (not filtered by Trust Person MID)
  getStoryOptions = () => {
    const { trustedStories } = this.props;
    
    if (!trustedStories || !Array.isArray(trustedStories)) return [];
    
    // Return all Story options without filtering
    return trustedStories.map((story) => {
      const assignedInfo = story.ref_etsy_info_pack_mid ? ` [Đã gán: ${story.ref_etsy_info_pack_mid}]` : '';
      return {
        value: story.MID,
        label: `${story.MID} - ${story.artist_name } | ${story.etsy_shop_name}${assignedInfo}`
      };
    });
  }

  // Get all Device Pack options
  getDevicePackOptions = () => {
    const { devicePacks } = this.props;
    
    if (!devicePacks || !Array.isArray(devicePacks)) return [];
    
    // Return all Device Pack options
    return devicePacks.map((devicePack) => {
      const assignedInfo = devicePack.ref_etsy_info_pack_mid ? ` [Đã gán: ${devicePack.ref_etsy_info_pack_mid}]` : '';
      return {
        value: devicePack.location_id,
        label: `${devicePack.location_id} - ${devicePack.SN} | ${devicePack.status}${assignedInfo}`
      };
    });
  }

  // Get all SIM options
  getSimOptions = () => {
    const { sims } = this.props;
    
    if (!sims || !Array.isArray(sims)) return [];
    
    // Return all SIM options
    return sims.map((sim) => {
      const assignedInfo = sim.ref_etsy_info_pack_mid ? ` [Đã gán: ${sim.ref_etsy_info_pack_mid}]` : '';
      return {
        value: sim.number,
        label: `${sim.number} (${sim.mobile_network_provider || 'N/A'})${assignedInfo}`
      };
    });
  }

  // Get all Email options
  getEmailOptions = () => {
    const { emails } = this.props;
    
    if (!emails || !Array.isArray(emails)) return [];
    
    // Return all Email options
    return emails.map((email) => {
      const assignedInfo = email.ref_etsy_info_pack_mid ? ` [Đã gán: ${email.ref_etsy_info_pack_mid}]` : '';
      return {
        value: email.MID,
        label: `${email.MID} - ${email.email} (${email.name || 'N/A'})${assignedInfo}`
      };
    });
  }

  // Get Email 1 options (filtered by type EMAIL1)
  getEmail1Options = () => {
    const { emails } = this.props;
    
    if (!emails || !Array.isArray(emails)) return [];
    
    // Filter emails by type EMAIL1
    const email1Emails = emails.filter(email => email.type === 'EMAIL1');
    
    return email1Emails.map((email) => {
      const assignedInfo = email.ref_etsy_info_pack_mid ? ` [Đã gán: ${email.ref_etsy_info_pack_mid}]` : '';
      return {
        value: email.MID,
        label: `${email.MID} - ${email.email} (${email.name || 'N/A'})${assignedInfo}`
      };
    });
  }

  // Get Email 2 options (filtered by type EMAIL2)
  getEmail2Options = () => {
    const { emails } = this.props;
    
    if (!emails || !Array.isArray(emails)) return [];
    
    // Filter emails by type EMAIL2
    const email2Emails = emails.filter(email => email.type === 'EMAIL2');
    
    return email2Emails.map((email) => {
      const assignedInfo = email.ref_etsy_info_pack_mid ? ` [Đã gán: ${email.ref_etsy_info_pack_mid}]` : '';
      return {
        value: email.MID,
        label: `${email.MID} - ${email.email} (${email.name || 'N/A'})${assignedInfo}`
      };
    });
  }

  // Get all Scan Person options
  getScanPersonOptions = () => {
    const { scanPersons } = this.props;
    
    if (!scanPersons || !Array.isArray(scanPersons)) return [];
    
    // Return all Scan Person options
    return scanPersons.map((person) => {
      const assignedInfo = person.ref_etsy_info_pack_mid ? ` [Đã gán: ${person.ref_etsy_info_pack_mid}]` : '';
      return {
        value: person.MID,
        label: `${person.MID} - ${person.name}${assignedInfo}`
      };
    });
  }

  handleSubmitEdit = async () => {
    try {
      this.setState({ loading: true });
      
      const { selectedEtsyInfoPack, editFormData } = this.state;
      
      if (this.state.isEditMode) {
        await this.props.updateTKT1EtsyInfoPack(selectedEtsyInfoPack._id, editFormData);
        this.showToast('Cập nhật Etsy Info Pack thành công!', 'success');
      } else {
        await this.props.createTKT1EtsyInfoPack(editFormData);
        this.showToast('Thêm Etsy Info Pack mới thành công!', 'success');
      }
      
      const apiQuery = this.prepareApiQuery(this.state.query);
      await this.props.getTKT1EtsyInfoPacks(apiQuery);
      
      this.setState({
        showEditModal: false,
        showCreateModal: false,
        selectedEtsyInfoPack: null,
        isEditMode: false,
        loading: false
      });
      
    } catch (error) {
      console.error('Error saving etsy info pack:', error);
      this.showToast('Có lỗi xảy ra khi lưu dữ liệu!', 'error');
      this.setState({ loading: false });
    }
  }

  handleCloseCreateModal = () => {
    this.setState({
      showCreateModal: false,
      selectedEtsyInfoPack: null,
      isEditMode: false
    });
  }


  handleEditClick = (pack) => {
    this.setState({
      showEditModal: true,
      selectedEtsyInfoPack: pack,
      isEditMode: true,
      editFormData: {
        trusted_person_mid: pack.trusted_person_mid || '',
        valid_c3d_number: pack.valid_c3d_number || '',
        scan_person_mid: pack.scan_person_mid || '',
        trusted_bank_acc_mid: pack.trusted_bank_acc_mid || '',
        trusted_bank_visa_mid: pack.trusted_bank_visa_mid || '',
        device_pack_location_id: pack.device_pack_location_id || '',
        trusted_story_mid: pack.trusted_story_mid || '',
        sim_mid: pack.sim_mid || '',
        seller_address: pack.seller_address || '',
        email1_mid: pack.email1_mid || '',
        email2_mid: pack.email2_mid || '',
        buyer_registration_date: pack.buyer_registration_date || '',
        seller_registration_date: pack.seller_registration_date || '',
        note: pack.note || '',
        status: pack.status || 'active',
        metadata: pack.metadata || {},
        is_active: pack.is_active !== undefined ? pack.is_active : true
      }
    }, () => {
      // Load dependent data for the selected Trust Person MID
      if (pack.trusted_person_mid) {
        this.loadDependentData(pack.trusted_person_mid);
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedEtsyInfoPack: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedEtsyInfoPack: null,
      isEditMode: false
    });
  }

  handleConfigChange = (column, value) => {
    this.setState(prevState => ({
      showColumns: {
        ...prevState.showColumns,
        [column]: value
      }
    }));
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config to localStorage
      localStorage.setItem('TKT1EtsyInfoPack_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  handleSaveConfig = () => {
    localStorage.setItem('TKT1EtsyInfoPack_ViewConfig', JSON.stringify(this.state.showColumns));
    this.setState({ showConfigModal: false });
  }

  handleCloseConfigModal = () => {
    this.setState({ showConfigModal: false });
  }

  // Info modal handlers
  handleViewTrustedPersonInfo = (mid) => {
    // Find the current etsy info pack that contains this trusted person
    const currentPack = this.props.etsyInfoPacks?.find(pack => pack.trusted_person_mid === mid);
    
    if (currentPack && currentPack.trusted_person_info) {
      this.setState({
        showTrustedPersonInfoModal: true,
        selectedInfoData: currentPack.trusted_person_info
      });
    } else {
      this.showToast('Không tìm thấy thông tin Trusted Person!', 'error');
    }
  }

  handleViewC3DInfo = (c3dNumber) => {
    // Find the current etsy info pack that contains this C3D
    const currentPack = this.props.etsyInfoPacks?.find(pack => pack.valid_c3d_number === c3dNumber);
    
    if (currentPack && currentPack.valid_c3d_person_info) {
      this.setState({
        showC3DInfoModal: true,
        selectedInfoData: currentPack.valid_c3d_person_info
      });
    } else {
      this.showToast('Không tìm thấy thông tin C3D!', 'error');
    }
  }

  handleViewScanPersonInfo = (mid) => {
    // Find the current etsy info pack that contains this scan person
    const currentPack = this.props.etsyInfoPacks?.find(pack => pack.scan_person_mid === mid);
    
    if (currentPack && currentPack.scan_person_info) {
      this.setState({
        showScanPersonInfoModal: true,
        selectedInfoData: currentPack.scan_person_info
      });
    } else {
      this.showToast('Không tìm thấy thông tin Scan Person!', 'error');
    }
  }

  handleViewBankAccountInfo = (mid) => {
    // Find the current etsy info pack that contains this bank account
    const currentPack = this.props.etsyInfoPacks?.find(pack => pack.trusted_bank_acc_mid === mid);
    
    if (currentPack && currentPack.trusted_bank_account_info) {
      // Merge bank account info with trusted person info
      const bankAccountData = {
        ...currentPack.trusted_bank_account_info,
        trusted_person_info: currentPack.trusted_person_info
      };
      
      this.setState({
        showBankAccountInfoModal: true,
        selectedInfoData: bankAccountData
      });
    } else {
      this.showToast('Không tìm thấy thông tin Bank Account!', 'error');
    }
  }

  handleViewBankVisaInfo = (mid) => {
    // Find the current etsy info pack that contains this bank visa
    const currentPack = this.props.etsyInfoPacks?.find(pack => pack.trusted_bank_visa_mid === mid);
    
    if (currentPack && currentPack.trusted_bank_visa_info) {
      // Merge bank visa info with trusted person info
      const bankVisaData = {
        ...currentPack.trusted_bank_visa_info,
        trusted_person_info: currentPack.trusted_person_info
      };
      
      this.setState({
        showBankVisaInfoModal: true,
        selectedInfoData: bankVisaData
      });
    } else {
      this.showToast('Không tìm thấy thông tin Bank Visa!', 'error');
    }
  }

  handleViewDevicePackInfo = (locationId) => {
    // Find the current etsy info pack that contains this device pack
    const currentPack = this.props.etsyInfoPacks?.find(pack => pack.device_pack_location_id === locationId);
    
    if (currentPack && currentPack.device_pack_info) {
      this.setState({
        showDevicePackInfoModal: true,
        selectedInfoData: currentPack.device_pack_info
      });
    } else {
      this.showToast('Không tìm thấy thông tin Device Pack!', 'error');
    }
  }

  handleViewStoryInfo = (mid) => {
    // Find the current etsy info pack that contains this story
    const currentPack = this.props.etsyInfoPacks?.find(pack => pack.trusted_story_mid === mid);
    
    if (currentPack && currentPack.trusted_story_info) {
      this.setState({
        showStoryInfoModal: true,
        selectedInfoData: currentPack.trusted_story_info
      });
    } else {
      this.showToast('Không tìm thấy thông tin Story!', 'error');
    }
  }

  // Close info modal handlers
  handleCloseTrustedPersonInfoModal = () => {
    this.setState({ showTrustedPersonInfoModal: false, selectedInfoData: null });
  }

  handleCloseC3DInfoModal = () => {
    this.setState({ showC3DInfoModal: false, selectedInfoData: null });
  }

  handleCloseScanPersonInfoModal = () => {
    this.setState({ showScanPersonInfoModal: false, selectedInfoData: null });
  }

  handleCloseBankAccountInfoModal = () => {
    this.setState({ showBankAccountInfoModal: false, selectedInfoData: null });
  }

  handleCloseBankVisaInfoModal = () => {
    this.setState({ showBankVisaInfoModal: false, selectedInfoData: null });
  }

  handleCloseDevicePackInfoModal = () => {
    this.setState({ showDevicePackInfoModal: false, selectedInfoData: null });
  }

  handleCloseStoryInfoModal = () => {
    this.setState({ showStoryInfoModal: false, selectedInfoData: null });
  }

  handleEtsyInfoPackClick = (mid) => {
    if (mid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${mid}`,
        iframeTitle: `Etsy Info Pack Detail - ${mid}`
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  handleViewSetupEtsyInfo = (pack) => {
    this.setState({
      showSetupEtsyInfoModal: true,
      selectedEtsyInfoPack: pack
    });
  }

  handleOpenDetailInNewTab = (pack) => {
    if (pack.MID) {
      const detailUrl = `/admin/tkt1-etsy/etsy-info-pack-detail/${pack.MID}`;
      window.open(detailUrl, '_blank');
    }
  }

  handleCloseSetupEtsyInfoModal = () => {
    this.setState({ 
      showSetupEtsyInfoModal: false, 
      selectedEtsyInfoPack: null 
    });
  }

  handleViewSimInfo = (simInfo) => {
    this.setState({
      showSimInfoModal: true,
      selectedSimInfo: simInfo
    });
  }

  handleCloseSimInfoModal = () => {
    this.setState({
      showSimInfoModal: false,
      selectedSimInfo: null
    });
  }

  handleViewEmail1Info = (emailInfo) => {
    this.setState({
      showEmail1InfoModal: true,
      selectedEmailInfo: emailInfo
    });
  }

  handleCloseEmail1InfoModal = () => {
    this.setState({
      showEmail1InfoModal: false,
      selectedEmailInfo: null
    });
  }

  handleViewEmail2Info = (emailInfo) => {
    this.setState({
      showEmail2InfoModal: true,
      selectedEmailInfo: emailInfo
    });
  }

  handleCloseEmail2InfoModal = () => {
    this.setState({
      showEmail2InfoModal: false,
      selectedEmailInfo: null
    });
  }

  // Photo modal handlers
  handlePhotosClick = (photos) => {
    this.setState({
      showPhotosModal: true,
      selectedPhotos: photos || [],
      currentPhotoIndex: 0
    });
  }

  handleClosePhotosModal = () => {
    this.setState({
      showPhotosModal: false,
      selectedPhotos: [],
      currentPhotoIndex: 0
    });
  }

  // Note modal handlers
  handleNoteClick = (pack) => {
    this.setState({
      showNoteModal: true,
      selectedNoteData: {
        MID: pack.MID,
        trusted_person_mid: pack.trusted_person_mid,
        valid_c3d_number: pack.valid_c3d_number,
        note: pack.note
      }
    });
  }

  handleCloseNoteModal = () => {
    this.setState({
      showNoteModal: false,
      selectedNoteData: null
    });
  }

  // Helper function to truncate note text
  truncateNote = (note, maxLength = 50) => {
    if (!note || note.length <= maxLength) {
      return note;
    }
    return note.substring(0, maxLength) + '...';
  }

  // Column resizing handlers
  resetColumnWidths = () => {
    this.setState({ columnWidths: this.initColumnWidths });
    localStorage.removeItem('TKT1EtsyInfoPack_ColumnWidths');
  }


  handleMouseDown = (e, columnKey) => {
    e.preventDefault();
    e.stopPropagation();
    
    this.setState({
      isResizing: true,
      resizingColumn: columnKey,
      resizeStartX: e.clientX,
      resizeStartWidth: this.state.columnWidths[columnKey]
    });
    
    document.body.classList.add('table-resizing');
  }

  handleMouseMove = (e) => {
    if (!this.state.isResizing || !this.state.resizingColumn) return;
    
    e.preventDefault();
    const deltaX = e.clientX - this.state.resizeStartX;
    const newWidth = Math.max(50, this.state.resizeStartWidth + deltaX);
    const resizingColumn = this.state.resizingColumn;
    
    this.setState(prevState => ({
      columnWidths: {
        ...prevState.columnWidths,
        [resizingColumn]: newWidth
      }
    }));
  }

  handleMouseUp = () => {
    if (this.state.isResizing) {
      this.setState({
        isResizing: false,
        resizingColumn: null,
        resizeStartX: null,
        resizeStartWidth: null
      });
      
      document.body.classList.remove('table-resizing');
      
      // Save column widths to localStorage
      localStorage.setItem('TKT1EtsyInfoPack_ColumnWidths', JSON.stringify(this.state.columnWidths));
    }
  }

  handlePrevPhoto = () => {
    this.setState(prevState => ({
      currentPhotoIndex: prevState.currentPhotoIndex > 0 
        ? prevState.currentPhotoIndex - 1 
        : prevState.selectedPhotos.length - 1
    }));
  }

  handleNextPhoto = () => {
    this.setState(prevState => ({
      currentPhotoIndex: prevState.currentPhotoIndex < prevState.selectedPhotos.length - 1 
        ? prevState.currentPhotoIndex + 1 
        : 0
    }));
  }

  handleDownloadImage = (imageUrl, fileName) => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  handleKeyDown = (e) => {
    // Only handle keyboard events when photos modal is open
    if (!this.state.showPhotosModal) {
      return;
    }

    switch (e.key) {
      case 'ArrowLeft':
        if (this.state.selectedPhotos.length > 1) {
          e.preventDefault();
          this.handlePrevPhoto();
        }
        break;
      case 'ArrowRight':
        if (this.state.selectedPhotos.length > 1) {
          e.preventDefault();
          this.handleNextPhoto();
        }
        break;
      case 'Escape':
        e.preventDefault();
        this.handleClosePhotosModal();
        break;
      default:
        break;
    }
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim(),
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ etsyInfoPacks: [] }, () => {
        this.updateUrl(trimmedQuery)
        this.props.getTKT1EtsyInfoPacks(apiQuery);
        localStorage.setItem('tkt1_etsy_info_pack_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="4">
          <InputGroup>
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo MID, email..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={(e) => {
                const newQuery = { ...this.state.query, status: e.target.value };
                this.setState({ query: newQuery });
                localStorage.setItem('tkt1_etsy_info_pack_query', JSON.stringify(newQuery));
                
                const trimmedQuery = {
                  ...newQuery,
                  search: this.state.query.search.trim(),
                  status: newQuery.status
                };
                const apiQuery = this.prepareApiQuery(trimmedQuery);
                this.updateUrl(trimmedQuery);
                this.props.getTKT1EtsyInfoPacks(apiQuery);
              }}
            >
              <option value="">Tất cả</option>
              <option value="active">Hoạt động</option>
              <option value="inactive">Không hoạt động</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={(e) => {
                const newQuery = { ...this.state.query, sortBy: e.target.value };
                this.setState({ query: newQuery });
                localStorage.setItem('tkt1_etsy_info_pack_query', JSON.stringify(newQuery));
                
                const trimmedQuery = {
                  ...newQuery,
                  search: this.state.query.search.trim(),
                  status: this.state.query.status
                };
                const apiQuery = this.prepareApiQuery(trimmedQuery);
                this.updateUrl(trimmedQuery);
                this.props.getTKT1EtsyInfoPacks(apiQuery);
              }}
            >
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="trusted_person_mid">Trust Person MID</option>
              <option value="valid_c3d_number">C3D Number</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={(e) => {
                const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
                this.setState({ query: newQuery });
                localStorage.setItem('tkt1_etsy_info_pack_query', JSON.stringify(newQuery));
                
                const trimmedQuery = {
                  ...newQuery,
                  search: this.state.query.search.trim(),
                  status: this.state.query.status
                };
                const apiQuery = this.prepareApiQuery(trimmedQuery);
                this.updateUrl(trimmedQuery);
                this.props.getTKT1EtsyInfoPacks(apiQuery);
              }}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2" className="d-flex align-items-center">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderEtsyInfoPackTable = () => {
    const { etsyInfoPacks } = this.props;
    const { showColumns, columnWidths } = this.state;
    
    const safePacks = Array.isArray(etsyInfoPacks) ? etsyInfoPacks.filter(pack => pack != null && typeof pack === 'object') : [];
    
    if (!safePacks || safePacks.length === 0) {
      return (
        <Table striped bordered hover style={{ tableLayout: 'auto' }}>
          <thead>
            <tr>
              <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
                STT
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
                />
              </th>
              {showColumns.mid && <th style={{ width: `${columnWidths.mid}px`, position: 'relative' }}>
                MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'mid')}
                />
              </th>}
              {showColumns.shop_name && <th style={{ width: `${columnWidths.shop_name}px`, position: 'relative' }}>
                Shop Name
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'shop_name')}
                />
              </th>}
              {showColumns.seller_name && <th style={{ width: `${columnWidths.seller_name}px`, position: 'relative' }}>
                Seller Name
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'seller_name')}
                />
              </th>}
              {showColumns.trusted_story_mid && <th style={{ width: `${columnWidths.trusted_story_mid}px`, position: 'relative' }}>
                Story MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'trusted_story_mid')}
                />
              </th>}
              {showColumns.trusted_person_mid && <th style={{ width: `${columnWidths.trusted_person_mid}px`, position: 'relative' }}>
                Trust Person MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'trusted_person_mid')}
                />
              </th>}
              {showColumns.valid_c3d_number && <th style={{ width: `${columnWidths.valid_c3d_number}px`, position: 'relative' }}>
                C3D Number
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'valid_c3d_number')}
                />
              </th>}
              {showColumns.scan_person_mid && <th style={{ width: `${columnWidths.scan_person_mid}px`, position: 'relative' }}>
                Scan Person MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'scan_person_mid')}
                />
              </th>}
              {showColumns.trusted_bank_acc_mid && <th style={{ width: `${columnWidths.trusted_bank_acc_mid}px`, position: 'relative' }}>
                Bank Account MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'trusted_bank_acc_mid')}
                />
              </th>}
              {showColumns.trusted_bank_visa_mid && <th style={{ width: `${columnWidths.trusted_bank_visa_mid}px`, position: 'relative' }}>
                Bank Visa MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'trusted_bank_visa_mid')}
                />
              </th>}
              {showColumns.device_pack_location_id && <th style={{ width: `${columnWidths.device_pack_location_id}px`, position: 'relative' }}>
                Device Pack Location
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'device_pack_location_id')}
                />
              </th>}
              {showColumns.sim_mid && <th style={{ width: `${columnWidths.sim_mid}px`, position: 'relative' }}>
                Số SIM
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'sim_mid')}
                />
              </th>}
              {showColumns.seller_address && <th style={{ width: `${columnWidths.seller_address}px`, position: 'relative' }}>
                Địa chỉ người bán
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'seller_address')}
                />
              </th>}
              {showColumns.email1_mid && <th style={{ width: `${columnWidths.email1_mid}px`, position: 'relative' }}>
                Email 1 MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'email1_mid')}
                />
              </th>}
              {showColumns.email2_mid && <th style={{ width: `${columnWidths.email2_mid}px`, position: 'relative' }}>
                Email 2 MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'email2_mid')}
                />
              </th>}
              {showColumns.buyer_registration_date && <th style={{ width: `${columnWidths.buyer_registration_date}px`, position: 'relative' }}>
                Buyer Registration Date
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'buyer_registration_date')}
                />
              </th>}
              {showColumns.seller_registration_date && <th style={{ width: `${columnWidths.seller_registration_date}px`, position: 'relative' }}>
                Seller Registration Date
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'seller_registration_date')}
                />
              </th>}
              {showColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
                Ghi chú
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'note')}
                />
              </th>}
              {showColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
                Trạng thái
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'status')}
                />
              </th>}
              {showColumns.is_active && <th style={{ width: `${columnWidths.is_active}px`, position: 'relative' }}>
                Hoạt động
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'is_active')}
                />
              </th>}
              {showColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
                Ngày tạo
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
                />
              </th>}
              <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover style={{ tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
              STT
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
              />
            </th>
            {showColumns.mid && <th style={{ width: `${columnWidths.mid}px`, position: 'relative' }}>
              MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'mid')}
              />
            </th>}
            {showColumns.shop_name && <th style={{ width: `${columnWidths.shop_name}px`, position: 'relative' }}>
              Shop Name
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'shop_name')}
              />
            </th>}
            {showColumns.seller_name && <th style={{ width: `${columnWidths.seller_name}px`, position: 'relative' }}>
              Seller Name
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'seller_name')}
              />
            </th>}
            {showColumns.trusted_story_mid && <th style={{ width: `${columnWidths.trusted_story_mid}px`, position: 'relative' }}>
              Story MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'trusted_story_mid')}
              />
            </th>}
            {showColumns.trusted_person_mid && <th style={{ width: `${columnWidths.trusted_person_mid}px`, position: 'relative' }}>
              Trust Person MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'trusted_person_mid')}
              />
            </th>}
            {showColumns.valid_c3d_number && <th style={{ width: `${columnWidths.valid_c3d_number}px`, position: 'relative' }}>
              C3D Number
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'valid_c3d_number')}
              />
            </th>}
            {showColumns.scan_person_mid && <th style={{ width: `${columnWidths.scan_person_mid}px`, position: 'relative' }}>
              Scan Person MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'scan_person_mid')}
              />
            </th>}
            {showColumns.trusted_bank_acc_mid && <th style={{ width: `${columnWidths.trusted_bank_acc_mid}px`, position: 'relative' }}>
              Bank Account MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'trusted_bank_acc_mid')}
              />
            </th>}
            {showColumns.trusted_bank_visa_mid && <th style={{ width: `${columnWidths.trusted_bank_visa_mid}px`, position: 'relative' }}>
              Bank Visa MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'trusted_bank_visa_mid')}
              />
            </th>}
            {showColumns.device_pack_location_id && <th style={{ width: `${columnWidths.device_pack_location_id}px`, position: 'relative' }}>
              Device Pack Location
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'device_pack_location_id')}
              />
            </th>}
            {showColumns.sim_mid && <th style={{ width: `${columnWidths.sim_mid}px`, position: 'relative' }}>
              Số SIM
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'sim_mid')}
              />
            </th>}
            {showColumns.seller_address && <th style={{ width: `${columnWidths.seller_address}px`, position: 'relative' }}>
              Địa chỉ người bán
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'seller_address')}
              />
            </th>}
            {showColumns.email1_mid && <th style={{ width: `${columnWidths.email1_mid}px`, position: 'relative' }}>
              Email 1 MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'email1_mid')}
              />
            </th>}
            {showColumns.email2_mid && <th style={{ width: `${columnWidths.email2_mid}px`, position: 'relative' }}>
              Email 2 MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'email2_mid')}
              />
            </th>}
            {showColumns.buyer_registration_date && <th style={{ width: `${columnWidths.buyer_registration_date}px`, position: 'relative' }}>
              Buyer Registration Date
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'buyer_registration_date')}
              />
            </th>}
            {showColumns.seller_registration_date && <th style={{ width: `${columnWidths.seller_registration_date}px`, position: 'relative' }}>
              Seller Registration Date
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'seller_registration_date')}
              />
            </th>}
            {showColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
              Ghi chú
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'note')}
              />
            </th>}
            {showColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
              Trạng thái
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'status')}
              />
            </th>}
            {showColumns.is_active && <th style={{ width: `${columnWidths.is_active}px`, position: 'relative' }}>
              Hoạt động
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'is_active')}
              />
            </th>}
            {showColumns.created_at && <th style={{ width: `${columnWidths.created_at}px`, position: 'relative' }}>
              Ngày tạo
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'created_at')}
              />
            </th>}
            <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safePacks.map((pack, index) => {
            if (!pack || typeof pack !== 'object') return null;
              
              return (
                <tr key={pack._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.mid && (
                    <td>
                      {pack.MID ? (
                        <Badge 
                          bg="info" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px',
                            cursor: 'pointer'
                          }}
                          onClick={() => this.handleEtsyInfoPackClick(pack.MID)}
                          title="Click để xem chi tiết Etsy Info Pack"
                        >
                          {pack.MID}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.shop_name && (
                    <td>
                      {pack.trusted_story_info?.etsy_shop_name ? (
                        <div className="d-flex align-items-center gap-2">
                          {/* Icon tròn theo trạng thái đăng ký */}
                          <span 
                            style={{
                              width: '12px',
                              height: '12px',
                              borderRadius: '50%',
                              backgroundColor: pack.seller_registration_date ? '#28a745' : // Đăng ký cả 2 -> xanh lá
                                           pack.buyer_registration_date ? '#007bff' : // Đăng ký buyer, chưa seller -> xanh dương
                                           '#dc3545', // Chưa đăng ký buyer -> đỏ
                              cursor: 'pointer',
                              display: 'inline-block'
                            }}
                            onClick={() => this.handleViewSetupEtsyInfo(pack)}
                            title="Setup Etsy Shop"
                          />
                          {pack.seller_registration_date ? (
                            // Có seller_registration_date -> Link đến Etsy
                            <>
                              <a 
                                href={`https://etsy.com/shop/${pack.trusted_story_info.etsy_shop_name}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-decoration-none"
                                style={{ color: '#007bff' }}
                                title={`Mở shop Etsy | ${pack.buyer_registration_date ? `Đăng ký buyer: ${this.formatDate(pack.buyer_registration_date)}` : 'Chưa đăng ký buyer'} | Đăng ký seller: ${this.formatDate(pack.seller_registration_date)}`}
                              >
                                {pack.trusted_story_info.etsy_shop_name}
                              </a>
                              <FaExternalLinkAlt 
                                size={12} 
                                style={{ cursor: 'pointer', color: '#6c757d' }}
                                onClick={() => window.open(`https://etsy.com/shop/${pack.trusted_story_info.etsy_shop_name}`, '_blank')}
                                title="Mở shop Etsy"
                              />
                            </>
                          ) : pack.buyer_registration_date ? (
                            // Không có seller_registration_date nhưng có buyer_registration_date -> Text bình thường
                            <span 
                              title={`Đăng ký buyer: ${this.formatDate(pack.buyer_registration_date)} | Chưa đăng ký seller`}
                            >
                              {pack.trusted_story_info.etsy_shop_name}
                            </span>
                          ) : (
                            // Không có cả 2 -> Text màu đỏ
                            <span 
                              style={{ color: '#dc3545' }}
                              title="Chưa đăng ký buyer | Chưa đăng ký seller"
                            >
                              {pack.trusted_story_info.etsy_shop_name}
                            </span>
                          )}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.seller_name && (
                    <td>
                      {pack.trusted_story_info?.artist_name || '-'}
                    </td>
                  )}
                  {showColumns.trusted_story_mid && (
                    <td>
                      {pack.trusted_story_mid ? (
                        <Badge 
                          bg="dark" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px',
                            cursor: 'pointer'
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Table - Trusted Story MID clicked:', pack.trusted_story_mid);
                            this.handleViewStoryInfo(pack.trusted_story_mid);
                          }}
                          title="Click để xem thông tin Trusted Story"
                        >
                          {pack.trusted_story_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.trusted_person_mid && (
                    <td>
                      {pack.trusted_person_mid ? (
                        <Badge 
                          bg="primary" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px',
                            cursor: 'pointer'
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Table - Trust Person MID clicked:', pack.trusted_person_mid);
                            this.handleViewTrustedPersonInfo(pack.trusted_person_mid);
                          }}
                          title="Click để xem thông tin Trusted Person"
                        >
                          [{pack.trusted_person_mid}] {pack.trusted_person_info?.full_name || ''}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.valid_c3d_number && (
                    <td>
                      {pack.valid_c3d_number ? (
                        <Badge 
                          bg="info" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px',
                            cursor: 'pointer'
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Table - C3D Number clicked:', pack.valid_c3d_number);
                            this.handleViewC3DInfo(pack.valid_c3d_number);
                          }}
                          title="Click để xem thông tin C3D"
                        >
                          {pack.valid_c3d_number}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.scan_person_mid && (
                    <td>
                      {pack.scan_person_mid ? (
                        <Badge 
                          bg="warning" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px',
                            cursor: 'pointer'
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Table - Scan Person MID clicked:', pack.scan_person_mid);
                            this.handleViewScanPersonInfo(pack.scan_person_mid);
                          }}
                          title="Click để xem thông tin Scan Person"
                        >
                          [{pack.scan_person_mid}] {pack.scan_person_info?.name || ''}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.trusted_bank_acc_mid && (
                    <td>
                      {pack.trusted_bank_acc_mid ? (
                        <Badge 
                          bg="success" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px',
                            cursor: 'pointer'
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Table - Bank Account MID clicked:', pack.trusted_bank_acc_mid);
                            this.handleViewBankAccountInfo(pack.trusted_bank_acc_mid);
                          }}
                          title="Click để xem thông tin Bank Account"
                        >
                          {pack.trusted_bank_acc_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.trusted_bank_visa_mid && (
                    <td>
                      {pack.trusted_bank_visa_mid ? (
                        <Badge 
                          bg="secondary" 
                          style={{ 
                            fontSize: '0.9em', 
                            padding: '6px 10px',
                            cursor: 'pointer'
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Table - Bank Visa MID clicked:', pack.trusted_bank_visa_mid);
                            this.handleViewBankVisaInfo(pack.trusted_bank_visa_mid);
                          }}
                          title="Click để xem thông tin Bank Visa"
                        >
                          {pack.trusted_bank_visa_mid}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.device_pack_location_id && (
                    <td>
                      {pack.device_pack_location_id ? (
                        <Badge 
                          bg="info" 
                          style={{ 
                            fontSize: '0.8em', 
                            padding: '4px 8px',
                            cursor: 'pointer'
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Table - Device Pack Location clicked:', pack.device_pack_location_id);
                            this.handleViewDevicePackInfo(pack.device_pack_location_id);
                          }}
                          title="Click để xem thông tin Device Pack"
                        >
                          {pack.device_pack_location_id}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.sim_mid && (
                    <td>
                      {pack.sim_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="info" 
                            style={{ 
                              fontSize: '0.9em', 
                              padding: '6px 10px',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.handleViewSimInfo(pack.sim_info)}
                            title="Click để xem thông tin SIM"
                          >
                            {pack.sim_mid}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(pack.sim_mid)}
                            title="Copy SIM Number"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.seller_address && (
                    <td>
                      {pack.seller_address || '-'}
                    </td>
                  )}
                  {showColumns.email1_mid && (
                    <td>
                      {pack.email1_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="primary" 
                            style={{ 
                              fontSize: '0.9em', 
                              padding: '6px 10px',
                              cursor: 'pointer'
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (pack.email1_info) {
                                this.handleViewEmail1Info(pack.email1_info);
                              }
                            }}
                            title="Click để xem thông tin Email 1"
                          >
                            {pack.email1_mid}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(pack.email1_mid)}
                            title="Copy Email 1 MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.email2_mid && (
                    <td>
                      {pack.email2_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="secondary" 
                            style={{ 
                              fontSize: '0.9em', 
                              padding: '6px 10px',
                              cursor: 'pointer'
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (pack.email2_info) {
                                this.handleViewEmail2Info(pack.email2_info);
                              }
                            }}
                            title="Click để xem thông tin Email 2"
                          >
                            {pack.email2_mid}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(pack.email2_mid)}
                            title="Copy Email 2 MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.buyer_registration_date && (
                    <td>
                      {pack.buyer_registration_date ? this.formatDate(pack.buyer_registration_date) : '-'}
                    </td>
                  )}
                  {showColumns.seller_registration_date && (
                    <td>
                      {pack.seller_registration_date ? this.formatDate(pack.seller_registration_date) : '-'}
                    </td>
                  )}
                  {showColumns.note && (
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span 
                          style={{ 
                            whiteSpace: 'nowrap',
                            cursor: pack.note && pack.note.length > 50 ? 'pointer' : 'default'
                          }}
                          title={pack.note}
                          onClick={pack.note && pack.note.length > 50 ? () => this.handleNoteClick(pack) : undefined}
                        >
                          {this.truncateNote(pack.note)}
                        </span>
                        {pack.note && pack.note.length > 50 && (
                          <FaStickyNote 
                            size={12} 
                            style={{ 
                              cursor: 'pointer', 
                              color: '#6c757d',
                              flexShrink: 0
                            }}
                            onClick={() => this.handleNoteClick(pack)}
                            title="Xem ghi chú đầy đủ"
                          />
                        )}
                      </div>
                    </td>
                  )}
                  {showColumns.status && (
                    <td>
                      <Badge 
                        bg={pack.status === 'active' ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {pack.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                      </Badge>
                    </td>
                  )}
                  {showColumns.is_active && (
                    <td>
                      <Badge 
                        bg={pack.is_active ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {pack.is_active ? 'Có' : 'Không'}
                      </Badge>
                    </td>
                  )}
                  {showColumns.created_at && (
                    <td>{pack.created_at ? new Date(pack.created_at).toLocaleDateString('vi-VN') : '-'}</td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(pack)}
                      />
                      <FaExternalLinkAlt 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#007bff'
                        }}
                        title="Mở chi tiết trong tab mới"
                        onClick={() => this.handleOpenDetailInNewTab(pack)}
                      />
                      <FaCog 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#28a745'
                        }}
                        title="Setup Etsy Info"
                        onClick={() => this.handleViewSetupEtsyInfo(pack)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Etsy Info Pack
              </h2>
            </Col>
            <Col className="text-end" md="auto">
              <div className="d-flex gap-2">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => this.setState({ showConfigModal: true })}
                  title="Cấu hình hiển thị"
                >
                  <i className="fas fa-cog me-1"></i>
                  Cấu hình
                </Button>
                <Button
                  variant="success"
                  size="sm"
                  onClick={this.handleCreateClick}
                  title="Thêm Etsy Info Pack mới"
                >
                  <FaPlus /> Thêm mới
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={this.resetColumnWidths}
                  title="Reset chiều rộng cột về mặc định"
                >
                  <FaCog /> Reset cột
                </Button>
              </div>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={(e) => {
                      const itemsPerPage = parseInt(e.target.value);
                      const trimmedQuery = {
                        ...this.state.query,
                        itemsPerPage,
                        currentPage: 1,
                        search: this.state.query.search.trim(),
                        status: this.state.query.status
                      };
                      
                      const apiQuery = this.prepareApiQuery(trimmedQuery);
                      
                      this.setState({
                        query: { ...this.state.query, itemsPerPage, currentPage: 1 }
                      }, () => {
                        this.updateUrl(trimmedQuery);
                        this.props.getTKT1EtsyInfoPacks(apiQuery);
                        localStorage.setItem('tkt1_etsy_info_pack_query', JSON.stringify(trimmedQuery));
                      })
                    }}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="sticky-table">
                {this.renderEtsyInfoPackTable()}
              </div>
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Create Modal */}
        <Modal show={this.state.showCreateModal} onHide={this.handleCloseCreateModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-plus me-2"></i>
              Thêm Etsy Info Pack mới
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trust Person MID *</Form.Label>
                    <Select
                      value={this.props.trustedPersonInfos ? this.props.trustedPersonInfos
                        .map((person) => ({
                          value: person.MID,
                          label: `${person.MID} - ${person.full_name}${person.full_name_english ? ` (${person.full_name_english})` : ''}`
                        }))
                        .find(option => option.value === this.state.editFormData.trusted_person_mid) : null}
                      onChange={(selectedOption) => this.handleFormChange('trusted_person_mid', selectedOption ? selectedOption.value : '')}
                      options={this.props.trustedPersonInfos ? this.props.trustedPersonInfos.map((person) => ({
                        value: person.MID,
                        label: `${person.MID} - ${person.full_name}${person.full_name_english ? ` (${person.full_name_english})` : ''}`
                      })) : []}
                      placeholder="Chọn Trust Person..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Trust Person"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Valid C3D Number</Form.Label>
                    <Select
                      value={this.getFilteredC3DOptions().find(option => option.value === this.state.editFormData.valid_c3d_number) || null}
                      onChange={(selectedOption) => this.handleFormChange('valid_c3d_number', selectedOption ? selectedOption.value : '')}
                      options={this.getFilteredC3DOptions()}
                      placeholder={this.state.editFormData.trusted_person_mid ? "Chọn C3D Number..." : "Vui lòng chọn Trust Person MID trước"}
                      isSearchable
                      isClearable
                      isDisabled={!this.state.editFormData.trusted_person_mid}
                      noOptionsMessage={() => this.state.editFormData.trusted_person_mid ? "Không tìm thấy C3D Number cho Trust Person này" : "Vui lòng chọn Trust Person MID trước"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem',
                          backgroundColor: !this.state.editFormData.trusted_person_mid ? '#f8f9fa' : 'white'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Scan Person MID</Form.Label>
                    <Select
                      value={this.getScanPersonOptions().find(option => option.value === this.state.editFormData.scan_person_mid)}
                      onChange={(selectedOption) => this.handleFormChange('scan_person_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getScanPersonOptions()}
                      placeholder="Chọn Scan Person..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Scan Person"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trusted Bank Account MID</Form.Label>
                    <Select
                      value={this.getFilteredBankAccountOptions().find(option => option.value === this.state.editFormData.trusted_bank_acc_mid) || null}
                      onChange={(selectedOption) => this.handleFormChange('trusted_bank_acc_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getFilteredBankAccountOptions()}
                      placeholder={this.state.editFormData.trusted_person_mid ? "Chọn Bank Account..." : "Vui lòng chọn Trust Person MID trước"}
                      isSearchable
                      isClearable
                      isDisabled={!this.state.editFormData.trusted_person_mid}
                      noOptionsMessage={() => this.state.editFormData.trusted_person_mid ? "Không tìm thấy Bank Account cho Trust Person này" : "Vui lòng chọn Trust Person MID trước"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem',
                          backgroundColor: !this.state.editFormData.trusted_person_mid ? '#f8f9fa' : 'white'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trusted Bank Visa MID</Form.Label>
                    <Select
                      value={this.getFilteredBankVisaOptions().find(option => option.value === this.state.editFormData.trusted_bank_visa_mid) || null}
                      onChange={(selectedOption) => this.handleFormChange('trusted_bank_visa_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getFilteredBankVisaOptions()}
                      placeholder={this.state.editFormData.trusted_person_mid ? "Chọn Bank Visa..." : "Vui lòng chọn Trust Person MID trước"}
                      isSearchable
                      isClearable
                      isDisabled={!this.state.editFormData.trusted_person_mid}
                      noOptionsMessage={() => this.state.editFormData.trusted_person_mid ? "Không tìm thấy Bank Visa cho Trust Person này" : "Vui lòng chọn Trust Person MID trước"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem',
                          backgroundColor: !this.state.editFormData.trusted_person_mid ? '#f8f9fa' : 'white'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Device Pack Location ID</Form.Label>
                    <Select
                      value={this.getDevicePackOptions().find(option => option.value === this.state.editFormData.device_pack_location_id) || null}
                      onChange={(selectedOption) => this.handleFormChange('device_pack_location_id', selectedOption ? selectedOption.value : '')}
                      options={this.getDevicePackOptions()}
                      placeholder="Chọn Device Pack..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Device Pack"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trusted Story MID</Form.Label>
                    <Select
                      value={this.getStoryOptions().find(option => option.value === this.state.editFormData.trusted_story_mid) || null}
                      onChange={(selectedOption) => this.handleFormChange('trusted_story_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getStoryOptions()}
                      placeholder="Chọn Story..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Story"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Số SIM / Số điện thoại</Form.Label>
                    <Select
                      value={this.getSimOptions().find(option => option.value === this.state.editFormData.sim_mid)}
                      onChange={(selectedOption) => this.handleFormChange('sim_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getSimOptions()}
                      placeholder="Chọn SIM..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy SIM"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Địa chỉ người bán</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.seller_address}
                      onChange={(e) => this.handleFormChange('seller_address', e.target.value)}
                      placeholder="Nhập địa chỉ người bán"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleFormChange('status', e.target.value)}
                    >
                      <option value="active">Hoạt động</option>
                      <option value="inactive">Không hoạt động</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Email 1 MID</Form.Label>
                    <Select
                      value={this.getEmail1Options().find(option => option.value === this.state.editFormData.email1_mid)}
                      onChange={(selectedOption) => this.handleFormChange('email1_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getEmail1Options()}
                      placeholder="Chọn Email 1..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Email"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Email 2 MID</Form.Label>
                    <Select
                      value={this.getEmail2Options().find(option => option.value === this.state.editFormData.email2_mid)}
                      onChange={(selectedOption) => this.handleFormChange('email2_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getEmail2Options()}
                      placeholder="Chọn Email 2..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Email"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleFormChange('note', e.target.value)}
                      placeholder="Nhập ghi chú..."
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Hoạt động"
                      checked={this.state.editFormData.is_active}
                      onChange={(e) => this.handleFormChange('is_active', e.target.checked)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseCreateModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button 
              variant="primary" 
              onClick={this.handleSubmitEdit}
              disabled={this.state.loading}
            >
              {this.state.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Đang lưu...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-1"></i>
                  Lưu
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-edit me-2"></i>
              {this.state.isEditMode ? 'Chỉnh sửa Etsy Info Pack' : 'Thêm Etsy Info Pack mới'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trust Person MID *</Form.Label>
                    <Select
                      value={this.props.trustedPersonInfos ? this.props.trustedPersonInfos
                        .map((person) => ({
                          value: person.MID,
                          label: `${person.MID} - ${person.full_name}${person.full_name_english ? ` (${person.full_name_english})` : ''}`
                        }))
                        .find(option => option.value === this.state.editFormData.trusted_person_mid) : null}
                      onChange={(selectedOption) => this.handleFormChange('trusted_person_mid', selectedOption ? selectedOption.value : '')}
                      options={this.props.trustedPersonInfos ? this.props.trustedPersonInfos.map((person) => ({
                        value: person.MID,
                        label: `${person.MID} - ${person.full_name}${person.full_name_english ? ` (${person.full_name_english})` : ''}`
                      })) : []}
                      placeholder="Chọn Trust Person..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Trust Person"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Valid C3D Number</Form.Label>
                    <Select
                      value={this.getFilteredC3DOptions().find(option => option.value === this.state.editFormData.valid_c3d_number) || null}
                      onChange={(selectedOption) => this.handleFormChange('valid_c3d_number', selectedOption ? selectedOption.value : '')}
                      options={this.getFilteredC3DOptions()}
                      placeholder={this.state.editFormData.trusted_person_mid ? "Chọn C3D Number..." : "Vui lòng chọn Trust Person MID trước"}
                      isSearchable
                      isClearable
                      isDisabled={!this.state.editFormData.trusted_person_mid}
                      noOptionsMessage={() => this.state.editFormData.trusted_person_mid ? "Không tìm thấy C3D Number cho Trust Person này" : "Vui lòng chọn Trust Person MID trước"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem',
                          backgroundColor: !this.state.editFormData.trusted_person_mid ? '#f8f9fa' : 'white'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Scan Person MID</Form.Label>
                    <Select
                      value={this.getScanPersonOptions().find(option => option.value === this.state.editFormData.scan_person_mid)}
                      onChange={(selectedOption) => this.handleFormChange('scan_person_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getScanPersonOptions()}
                      placeholder="Chọn Scan Person..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Scan Person"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trusted Bank Account MID</Form.Label>
                    <Select
                      value={this.getFilteredBankAccountOptions().find(option => option.value === this.state.editFormData.trusted_bank_acc_mid) || null}
                      onChange={(selectedOption) => this.handleFormChange('trusted_bank_acc_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getFilteredBankAccountOptions()}
                      placeholder={this.state.editFormData.trusted_person_mid ? "Chọn Bank Account..." : "Vui lòng chọn Trust Person MID trước"}
                      isSearchable
                      isClearable
                      isDisabled={!this.state.editFormData.trusted_person_mid}
                      noOptionsMessage={() => this.state.editFormData.trusted_person_mid ? "Không tìm thấy Bank Account cho Trust Person này" : "Vui lòng chọn Trust Person MID trước"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem',
                          backgroundColor: !this.state.editFormData.trusted_person_mid ? '#f8f9fa' : 'white'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trusted Bank Visa MID</Form.Label>
                    <Select
                      value={this.getFilteredBankVisaOptions().find(option => option.value === this.state.editFormData.trusted_bank_visa_mid) || null}
                      onChange={(selectedOption) => this.handleFormChange('trusted_bank_visa_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getFilteredBankVisaOptions()}
                      placeholder={this.state.editFormData.trusted_person_mid ? "Chọn Bank Visa..." : "Vui lòng chọn Trust Person MID trước"}
                      isSearchable
                      isClearable
                      isDisabled={!this.state.editFormData.trusted_person_mid}
                      noOptionsMessage={() => this.state.editFormData.trusted_person_mid ? "Không tìm thấy Bank Visa cho Trust Person này" : "Vui lòng chọn Trust Person MID trước"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem',
                          backgroundColor: !this.state.editFormData.trusted_person_mid ? '#f8f9fa' : 'white'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Device Pack Location ID</Form.Label>
                    <Select
                      value={this.getDevicePackOptions().find(option => option.value === this.state.editFormData.device_pack_location_id) || null}
                      onChange={(selectedOption) => this.handleFormChange('device_pack_location_id', selectedOption ? selectedOption.value : '')}
                      options={this.getDevicePackOptions()}
                      placeholder="Chọn Device Pack..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Device Pack"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trusted Story MID</Form.Label>
                    <Select
                      value={this.getStoryOptions().find(option => option.value === this.state.editFormData.trusted_story_mid) || null}
                      onChange={(selectedOption) => this.handleFormChange('trusted_story_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getStoryOptions()}
                      placeholder="Chọn Story..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Story"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Số SIM / Số điện thoại</Form.Label>
                    <Select
                      value={this.getSimOptions().find(option => option.value === this.state.editFormData.sim_mid)}
                      onChange={(selectedOption) => this.handleFormChange('sim_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getSimOptions()}
                      placeholder="Chọn SIM..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy SIM"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Địa chỉ người bán</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.seller_address}
                      onChange={(e) => this.handleFormChange('seller_address', e.target.value)}
                      placeholder="Nhập địa chỉ người bán"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleFormChange('status', e.target.value)}
                    >
                      <option value="active">Hoạt động</option>
                      <option value="inactive">Không hoạt động</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Email 1 MID</Form.Label>
                    <Select
                      value={this.getEmail1Options().find(option => option.value === this.state.editFormData.email1_mid)}
                      onChange={(selectedOption) => this.handleFormChange('email1_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getEmail1Options()}
                      placeholder="Chọn Email 1..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Email"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Email 2 MID</Form.Label>
                    <Select
                      value={this.getEmail2Options().find(option => option.value === this.state.editFormData.email2_mid)}
                      onChange={(selectedOption) => this.handleFormChange('email2_mid', selectedOption ? selectedOption.value : '')}
                      options={this.getEmail2Options()}
                      placeholder="Chọn Email 2..."
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "Không tìm thấy Email"}
                      filterOption={(option, inputValue) => {
                        const searchTerm = inputValue.toLowerCase();
                        const label = option.label ? option.label.toLowerCase() : '';
                        return label.includes(searchTerm);
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '0.375rem'
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleFormChange('note', e.target.value)}
                      placeholder="Nhập ghi chú..."
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Ngày đăng ký người mua</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.buyer_registration_date}
                      onChange={(e) => this.handleFormChange('buyer_registration_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Ngày đăng ký người bán</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.seller_registration_date}
                      onChange={(e) => this.handleFormChange('seller_registration_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Hoạt động"
                      checked={this.state.editFormData.is_active}
                      onChange={(e) => this.handleFormChange('is_active', e.target.checked)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              <i className="fas fa-times me-1"></i>
              Hủy
            </Button>
            <Button 
              variant="primary" 
              onClick={this.handleSubmitEdit}
              disabled={this.state.loading}
            >
              {this.state.loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Đang lưu...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-1"></i>
                  Lưu
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Trusted Person Info Modal */}
        <Modal show={this.state.showTrustedPersonInfoModal} onHide={this.handleCloseTrustedPersonInfoModal} size="xl">
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>
              <i className="fas fa-user me-2"></i>
              Thông tin Trusted Person
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedInfoData && (
              <div>
                <Row>
                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-primary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-info-circle me-2"></i>
                          Thông tin cơ bản
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">MID:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                  {this.state.selectedInfoData.MID}
                                </Badge>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Tên đầy đủ:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0 fw-bold">{this.state.selectedInfoData.full_name}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Tên tiếng Anh:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.full_name_english || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Đầu mối:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.relation_with || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Ghi chú quan hệ:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.relation_note || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Thành phố hiện tại:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.current_city || '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-success text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-chart-bar me-2"></i>
                          Thống kê & Trạng thái
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Tổng C3D:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                  {this.state.selectedInfoData.matching_c3d_total || 0}
                                </Badge>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">C3D Tax:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                  {this.state.selectedInfoData.matching_c3d_tax_total || 0}
                                </Badge>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Tiến độ scan:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedInfoData.matching_c3d_total ? (
                                  <div className="d-flex align-items-center gap-2">
                                    <Badge 
                                      bg={
                                        Math.round((this.state.selectedInfoData.matching_c3d_tax_total || 0) / this.state.selectedInfoData.matching_c3d_total * 100) === 100 ? 'success' :
                                        Math.round((this.state.selectedInfoData.matching_c3d_tax_total || 0) / this.state.selectedInfoData.matching_c3d_total * 100) === 0 ? 'secondary' :
                                        'warning'
                                      }
                                      style={{ fontSize: '0.8em', padding: '4px 8px' }}
                                    >
                                      {Math.round((this.state.selectedInfoData.matching_c3d_tax_total || 0) / this.state.selectedInfoData.matching_c3d_total * 100)}%
                                    </Badge>
                                    <small className="text-muted">
                                      ({this.state.selectedInfoData.matching_c3d_tax_total || 0}/{this.state.selectedInfoData.matching_c3d_total})
                                    </small>
                                  </div>
                                ) : '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Đăng ký Etsy:</label>
                            </div>
                            <div className="col-8">
                              <Badge bg={this.state.selectedInfoData.is_registered_etsy ? 'success' : 'secondary'}>
                                {this.state.selectedInfoData.is_registered_etsy ? 'Đã đăng ký' : 'Chưa đăng ký'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Etsy Active:</label>
                            </div>
                            <div className="col-8">
                              <Badge bg={this.state.selectedInfoData.registered_etsy ? 'success' : 'danger'}>
                                {this.state.selectedInfoData.registered_etsy ? 'Hoạt động' : 'Không hoạt động'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-info text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-id-card me-2"></i>
                          Thông tin C3D
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Số C3D:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedInfoData.c3d_number ? (
                                  <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {this.state.selectedInfoData.c3d_number}
                                  </Badge>
                                ) : '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Ngày sinh:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.c3d_dob || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Giới tính:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedInfoData.c3d_sex === 'MALE' ? 'Nam' : 
                                 this.state.selectedInfoData.c3d_sex === 'FEMALE' ? 'Nữ' : 
                                 this.state.selectedInfoData.c3d_sex || '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Nơi sinh:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0" style={{ whiteSpace: 'nowrap' }} title={this.state.selectedInfoData.c3d_place_of_origin}>
                                {this.state.selectedInfoData.c3d_place_of_origin || '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Nơi cư trú:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0" style={{ whiteSpace: 'nowrap' }} title={this.state.selectedInfoData.c3d_place_of_residence}>
                                {this.state.selectedInfoData.c3d_place_of_residence || '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Thành phố:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.c3d_city || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Ảnh C3D:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedInfoData.c3d_photos && this.state.selectedInfoData.c3d_photos.length > 0 ? (
                                  <Badge bg="info">{this.state.selectedInfoData.c3d_photos.length} ảnh</Badge>
                                ) : '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-warning text-dark" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-map-marker-alt me-2"></i>
                          Thông tin liên hệ
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Địa chỉ:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0" style={{ whiteSpace: 'nowrap' }} title={this.state.selectedInfoData.address}>
                                {this.state.selectedInfoData.address || '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Số điện thoại:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.phone || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Ghi chú liên hệ:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0" style={{ whiteSpace: 'nowrap' }} title={this.state.selectedInfoData.contact_note}>
                                {this.state.selectedInfoData.contact_note || '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Metadata C3D:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedInfoData.c3d_metadata ? (
                                  <Badge bg="secondary">Có metadata</Badge>
                                ) : '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Đã xóa:</label>
                            </div>
                            <div className="col-8">
                              <Badge bg={this.state.selectedInfoData.is_deleted ? "danger" : "success"}>
                                {this.state.selectedInfoData.is_deleted ? "Đã xóa" : "Hoạt động"}
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <Card>
                      <Card.Header className="bg-secondary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-clock me-2"></i>
                          Thời gian
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-secondary">Ngày tạo:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">
                                    {this.state.selectedInfoData.created_at ? 
                                      new Date(this.state.selectedInfoData.created_at).toLocaleString('vi-VN', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit'
                                      }) : 
                                      '-'
                                    }
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-secondary">Cập nhật:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">
                                    {this.state.selectedInfoData.updated_at ? 
                                      new Date(this.state.selectedInfoData.updated_at).toLocaleString('vi-VN', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit'
                                      }) : 
                                      '-'
                                    }
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseTrustedPersonInfoModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* C3D Info Modal */}
        <Modal show={this.state.showC3DInfoModal} onHide={this.handleCloseC3DInfoModal} size="xl">
          <Modal.Header closeButton className="bg-info text-white">
            <Modal.Title>
              <i className="fas fa-id-card me-2"></i>
              Thông tin C3D
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedInfoData && (
              <div>
                <Row>
                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-info text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-info-circle me-2"></i>
                          Thông tin cơ bản
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">C3D Number:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center">
                                <p className="mb-0 me-2">{this.state.selectedInfoData.c3d_number}</p>
                                <FaCopy 
                                  size={14} 
                                  style={{ cursor: 'pointer', color: '#6c757d' }}
                                  onClick={() => this.copyToClipboard(this.state.selectedInfoData.c3d_number)}
                                  title="Copy C3D Number"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">CMT Number:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center">
                                <p className="mb-0 me-2">{this.state.selectedInfoData.cmt_number || '-'}</p>
                                {this.state.selectedInfoData.cmt_number && (
                                  <FaCopy 
                                    size={14} 
                                    style={{ cursor: 'pointer', color: '#6c757d' }}
                                    onClick={() => this.copyToClipboard(this.state.selectedInfoData.cmt_number)}
                                    title="Copy CMT Number"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Tên đầy đủ:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center">
                                <p className="mb-0 me-2">{this.state.selectedInfoData.full_name}</p>
                                <FaCopy 
                                  size={14} 
                                  style={{ cursor: 'pointer', color: '#6c757d' }}
                                  onClick={() => this.copyToClipboard(this.state.selectedInfoData.full_name)}
                                  title="Copy Tên đầy đủ"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Tên tiếng Anh:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.full_name_english || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Ngày sinh:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center">
                                <p className="mb-0 me-2">
                                  {this.formatDate(this.state.selectedInfoData.c3d_dob)}
                                </p>
                                {this.state.selectedInfoData.c3d_dob && (
                                  <FaCopy 
                                    size={14} 
                                    style={{ cursor: 'pointer', color: '#6c757d' }}
                                    onClick={() => this.copyToClipboard(this.state.selectedInfoData.c3d_dob)}
                                    title="Copy Ngày sinh"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Ngày cấp C3D:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center">
                   <p className="mb-0 me-2">
                     {this.formatDate(this.state.selectedInfoData.c3d_issue_date)}
                   </p>
                                {this.state.selectedInfoData.c3d_issue_date && (
                                  <FaCopy 
                                    size={14} 
                                    style={{ cursor: 'pointer', color: '#6c757d' }}
                                     onClick={() => this.copyToClipboard(
                                       this.formatDate(this.state.selectedInfoData.c3d_issue_date)
                                     )}
                                    title="Copy Ngày cấp C3D"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Ngày hết hạn C3D:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center">
                   <p className="mb-0 me-2">
                     {this.formatDate(this.state.selectedInfoData.c3d_expired_date)}
                   </p>
                                {this.state.selectedInfoData.c3d_expired_date && (
                                  <FaCopy 
                                    size={14} 
                                    style={{ cursor: 'pointer', color: '#6c757d' }}
                                     onClick={() => this.copyToClipboard(
                                       this.formatDate(this.state.selectedInfoData.c3d_expired_date)
                                     )}
                                    title="Copy Ngày hết hạn C3D"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Giới tính:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedInfoData.c3d_sex === 'MALE' ? 'Nam' : 
                                 this.state.selectedInfoData.c3d_sex === 'FEMALE' ? 'Nữ' : 
                                 this.state.selectedInfoData.c3d_sex || '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Thành phố:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.c3d_city || '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-success text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-map-marker-alt me-2"></i>
                          Thông tin địa chỉ
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Nơi sinh:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center">
                                <p className="mb-0 me-2">{this.state.selectedInfoData.c3d_place_of_origin || '-'}</p>
                                {this.state.selectedInfoData.c3d_place_of_origin && (
                                  <FaCopy 
                                    size={14} 
                                    style={{ cursor: 'pointer', color: '#6c757d' }}
                                    onClick={() => this.copyToClipboard(this.state.selectedInfoData.c3d_place_of_origin)}
                                    title="Copy Nơi sinh"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Nơi cư trú:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.c3d_place_of_residence || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Nguồn:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.source || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Trạng thái Etsy:</label>
                            </div>
                            <div className="col-8">
                              <Badge bg={
                                this.state.selectedInfoData.info_etsy_status === 'FOUND_TRUSTED_INFO' ? 'success' :
                                this.state.selectedInfoData.info_etsy_status === 'WAIT_FOR_TRUSTED_INFO' ? 'warning' :
                                this.state.selectedInfoData.info_etsy_status === 'REGISTERED' ? 'primary' :
                                this.state.selectedInfoData.info_etsy_status === 'SUSPENDED' ? 'danger' :
                                'secondary'
                              }>
                                {this.state.selectedInfoData.info_etsy_status === 'FOUND_TRUSTED_INFO' ? 'Đã tìm thấy người tin cậy' :
                                 this.state.selectedInfoData.info_etsy_status === 'WAIT_FOR_TRUSTED_INFO' ? 'Chờ thông tin người tin cậy' :
                                 this.state.selectedInfoData.info_etsy_status === 'REGISTERED' ? 'Đã đăng ký' :
                                 this.state.selectedInfoData.info_etsy_status === 'SUSPENDED' ? 'Bị tạm dừng' :
                                 this.state.selectedInfoData.info_etsy_status || '-'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Trust Person MID:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.ref_trusted_person_mid || '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <Card>
                      <Card.Header className="bg-warning text-dark" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-receipt me-2"></i>
                          Thông tin thuế TNCN
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        {this.state.selectedInfoData.TNCN_tax_infos && this.state.selectedInfoData.TNCN_tax_infos.length > 0 ? (
                          <div className="table-responsive">
                            <Table striped bordered hover size="sm">
                              <thead>
                                <tr>
                                  <th>Tên người nộp thuế</th>
                                  <th>Cơ quan thuế</th>
                                  <th>Thành phố</th>
                                  <th>Trạng thái</th>
                                  <th>Mô tả</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.selectedInfoData.TNCN_tax_infos.map((tax, index) => (
                                  <tr key={index}>
                                    <td>
                                      <Badge bg="info" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                        {tax.payer_name}
                                      </Badge>
                                    </td>
                                    <td>{tax.tax_authority}</td>
                                    <td>
                                      <Badge bg="success" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                        {tax.city}
                                      </Badge>
                                    </td>
                                    <td>
                                      <Badge bg={
                                        tax.status === 'ACTIVE' ? 'success' :
                                        tax.status === 'INACTIVE' ? 'danger' :
                                        tax.status === 'SUSPENDED' ? 'warning' :
                                        'secondary'
                                      } style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                        {tax.status}
                                      </Badge>
                                    </td>
                                    <td>{tax.status_text}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <i className="fas fa-info-circle me-2"></i>
                            Không có thông tin thuế TNCN
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <Card>
                      <Card.Header className="bg-primary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-building me-2"></i>
                          Thông tin thuế DN
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        {this.state.selectedInfoData.DN_tax_infos && this.state.selectedInfoData.DN_tax_infos.length > 0 ? (
                          <div className="table-responsive">
                            <Table striped bordered hover size="sm">
                              <thead>
                                <tr>
                                  <th>Tên người nộp thuế</th>
                                  <th>Cơ quan thuế</th>
                                  <th>Thành phố</th>
                                  <th>Trạng thái</th>
                                  <th>Mô tả</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.selectedInfoData.DN_tax_infos.map((tax, index) => (
                                  <tr key={index}>
                                    <td>
                                      <Badge bg="primary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                        {tax.payer_name}
                                      </Badge>
                                    </td>
                                    <td>{tax.tax_authority}</td>
                                    <td>
                                      <Badge bg="success" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                        {tax.city}
                                      </Badge>
                                    </td>
                                    <td>
                                      <Badge bg={
                                        tax.status === 'ACTIVE' ? 'success' :
                                        tax.status === 'INACTIVE' ? 'danger' :
                                        tax.status === 'SUSPENDED' ? 'warning' :
                                        'secondary'
                                      } style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                                        {tax.status}
                                      </Badge>
                                    </td>
                                    <td>{tax.status_text}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        ) : (
                          <div className="text-center text-muted">
                            <i className="fas fa-info-circle me-2"></i>
                            Không có thông tin thuế DN
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <Card>
                      <Card.Header className="bg-secondary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-chart-line me-2"></i>
                          Tổng quan thuế
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <Row>
                          <Col md="4">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-6">
                                  <label className="form-label fw-bold text-secondary">Kiểm tra thuế cuối:</label>
                                </div>
                                <div className="col-6">
                                  <p className="mb-0">
                                    {this.state.selectedInfoData.last_checked_tax ? 
                                      new Date(this.state.selectedInfoData.last_checked_tax).toLocaleString('vi-VN', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit'
                                      }) : 
                                      'Chưa kiểm tra'}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-6">
                                  <label className="form-label fw-bold text-secondary">Tax Info Main:</label>
                                </div>
                                <div className="col-6">
                                  <p className="mb-0">
                                    <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                      {this.state.selectedInfoData.tax_info_main || 0}
                                    </Badge>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-6">
                                  <label className="form-label fw-bold text-secondary">Tổng số thuế:</label>
                                </div>
                                <div className="col-6">
                                  <p className="mb-0">
                                    <Badge bg="success" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                      {(this.state.selectedInfoData.TNCN_tax_infos?.length || 0) + (this.state.selectedInfoData.DN_tax_infos?.length || 0)}
                                    </Badge>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <Card>
                      <Card.Header className="bg-secondary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-clock me-2"></i>
                          Thời gian
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-secondary">Ngày tạo:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.created_at ? new Date(this.state.selectedInfoData.created_at).toLocaleDateString('vi-VN') : '-'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-secondary">Cập nhật:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.updated_at ? new Date(this.state.selectedInfoData.updated_at).toLocaleDateString('vi-VN') : '-'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                {/* QR Code Section */}
                <Row className="mt-3">
                  <Col md="6">
                    <Card>
                      <Card.Header className="bg-success text-white" style={{ padding: '0.5rem 0.75rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-qrcode me-2"></i>
                          Mã QR C3D
                        </h6>
                      </Card.Header>
                      <Card.Body className="text-center" style={{ padding: '0.75rem' }}>
                        <div className="mb-2">
                          <small className="text-muted">{this.state.selectedInfoData.c3d_number}</small>
                        </div>
                        <div className="mb-3" id="qr-code-container">
                          <QRCodeSVG
                            value={this.generateQRData(this.state.selectedInfoData)}
                            size={150}
                            style={{ height: "auto", maxWidth: "100%", width: "100%", backgroundColor: 'transparent' }}
                          />
                        </div>
                        <div className="d-flex gap-2 justify-content-center">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => this.copyToClipboard(this.generateQRData(this.state.selectedInfoData))}
                          >
                            <FaCopy size={12} className="me-1" />
                            Copy
                          </Button>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => this.downloadQRAsPNG()}
                          >
                            <i className="fas fa-download me-1"></i>
                            PNG
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md="6">
                    <Card>
                      <Card.Header className="bg-info text-white" style={{ padding: '0.5rem 0.75rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-code me-2"></i>
                          Dữ liệu QR
                        </h6>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem' }}>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          value={this.generateQRData(this.state.selectedInfoData)}
                          readOnly
                          style={{ fontSize: '11px', fontFamily: 'monospace', resize: 'none' }}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                {/* MRZ Section */}
                <Row className="mt-3">
                  <Col>
                    <Card>
                      <Card.Header className="bg-warning text-dark" style={{ padding: '0.5rem 0.75rem' }}>
                        <h6 className="mb-0">
                          <i className="fas fa-passport me-2"></i>
                          MRZ (Machine Readable Zone) - TD1 (3x30)
                        </h6>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem' }}>
                        {(() => {
                          const mrz = this.generateMRZ(this.state.selectedInfoData);
                          if (!mrz) {
                            return (
                              <div className="text-center text-muted">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                Không thể tạo MRZ - thiếu thông tin hoặc định dạng không đúng
                              </div>
                            );
                          }
                          return (
                            <div>
                              <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h6 className="mb-0">MRZ Lines (3x30 characters):</h6>
                                  <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => this.copyToClipboard(mrz.allLines)}
                                  >
                                    <FaCopy size={12} className="me-1" />
                                    Copy All
                                  </Button>
                                </div>
                                <div className="bg-light p-3 rounded" style={{ fontFamily: 'Arial, sans-serif', fontSize: '18px', fontWeight: 'normal' }}>
                                  <div className="mb-1">
                                    <span className="text-muted me-2">1:</span>
                                    <span className="text-primary">{mrz.line1}</span>
                                    <FaCopy 
                                      size={12} 
                                      className="ms-2 text-muted" 
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => this.copyToClipboard(mrz.line1)}
                                      title="Copy Line 1"
                                    />
                                  </div>
                                  <div className="mb-1">
                                    <span className="text-muted me-2">2:</span>
                                    <span className="text-success">{mrz.line2}</span>
                                    <FaCopy 
                                      size={12} 
                                      className="ms-2 text-muted" 
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => this.copyToClipboard(mrz.line2)}
                                      title="Copy Line 2"
                                    />
                                  </div>
                                  <div>
                                    <span className="text-muted me-2">3:</span>
                                    <span className="text-info">{mrz.line3}</span>
                                    <FaCopy 
                                      size={12} 
                                      className="ms-2 text-muted" 
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => this.copyToClipboard(mrz.line3)}
                                      title="Copy Line 3"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <small className="text-muted">
                                    <strong>Document Info:</strong><br/>
                                    DocNum: {mrz.computed.docnum9_field} (CD: {mrz.computed.docnum_cd})<br/>
                                    Full12: {mrz.computed.full12} (CD: {mrz.computed.full12_cd})
                                  </small>
                                </div>
                                <div className="col-md-6">
                                  <small className="text-muted">
                                    <strong>Dates:</strong><br/>
                                    DOB: {mrz.computed.dob6} (CD: {mrz.computed.dob_cd})<br/>
                                    Expiry: {mrz.computed.expiry6} (CD: {mrz.computed.expiry_cd})
                                  </small>
                                </div>
                              </div>
                            </div>
                          );
                        })()}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseC3DInfoModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Scan Person Info Modal */}
        <Modal show={this.state.showScanPersonInfoModal} onHide={this.handleCloseScanPersonInfoModal} size="xl">
          <Modal.Header closeButton className="bg-warning text-dark">
            <Modal.Title>
              <i className="fas fa-scan me-2"></i>
              Thông tin Scan Person
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedInfoData && (
              <div>
                <Row>
                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-warning text-dark" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-info-circle me-2"></i>
                          Thông tin cơ bản
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">MID:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.MID}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Tên:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.name}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Địa chỉ:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.address || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Thành phố:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.current_city || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Số điện thoại:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.phone || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Facebook:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedInfoData.facebook_link ? (
                                  <a href={this.state.selectedInfoData.facebook_link} target="_blank" rel="noopener noreferrer">
                                    <FaExternalLinkAlt size={14} className="me-1" />
                                    {this.state.selectedInfoData.facebook_link}
                                  </a>
                                ) : '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Google Drive:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedInfoData.google_drive_link ? (
                                  <a href={this.state.selectedInfoData.google_drive_link} target="_blank" rel="noopener noreferrer">
                                    <FaExternalLinkAlt size={14} className="me-1" />
                                    {this.state.selectedInfoData.google_drive_link}
                                  </a>
                                ) : '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Etsy Info Pack MID:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedInfoData.ref_etsy_info_pack_mid ? (
                                  <Badge bg="success" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                    {this.state.selectedInfoData.ref_etsy_info_pack_mid}
                                  </Badge>
                                ) : '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-warning">Trạng thái:</label>
                            </div>
                            <div className="col-8">
                              <Badge bg={this.state.selectedInfoData.is_active ? 'success' : 'danger'}>
                                {this.state.selectedInfoData.is_active ? 'Hoạt động' : 'Không hoạt động'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-info text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-id-card me-2"></i>
                          Thông tin C3D
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">C3D Number:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.c3d_number || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Ngày sinh:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.c3d_dob || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Giới tính:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.c3d_sex || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Nơi sinh:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.c3d_place_of_origin || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Nơi cư trú:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.c3d_place_of_residence || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Thành phố:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.c3d_city || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">C3D Ảnh:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center gap-2">
                                <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                  {this.state.selectedInfoData.c3d_photos?.length || 0} ảnh
                                </Badge>
                                {this.state.selectedInfoData.c3d_photos && this.state.selectedInfoData.c3d_photos.length > 0 && (
                                  <Button
                                    variant="outline-info"
                                    size="sm"
                                    onClick={() => this.handlePhotosClick(this.state.selectedInfoData.c3d_photos)}
                                    title="Xem tất cả ảnh C3D"
                                  >
                                    <i className="fas fa-images me-1"></i>
                                    Xem ảnh C3D
                                  </Button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <Card>
                      <Card.Header className="bg-secondary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-sticky-note me-2"></i>
                          Ghi chú & Liên hệ
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-secondary">Ghi chú liên hệ:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.contact_note || '-'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-secondary">Ngày tạo:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.created_at ? new Date(this.state.selectedInfoData.created_at).toLocaleDateString('vi-VN') : '-'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-secondary">Cập nhật:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.updated_at ? new Date(this.state.selectedInfoData.updated_at).toLocaleDateString('vi-VN') : '-'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-secondary">Số ảnh:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center gap-2">
                                <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                  {this.state.selectedInfoData.photos?.length || 0} ảnh
                                </Badge>
                                {this.state.selectedInfoData.photos && this.state.selectedInfoData.photos.length > 0 && (
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => this.handlePhotosClick(this.state.selectedInfoData.photos)}
                                    title="Xem tất cả ảnh"
                                  >
                                    <i className="fas fa-images me-1"></i>
                                    Xem ảnh
                                  </Button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                {/* C3D Metadata Section */}
                {this.state.selectedInfoData.c3d_metadata && Object.keys(this.state.selectedInfoData.c3d_metadata).length > 0 && (
                  <Row className="mt-4">
                    <Col>
                      <Card>
                        <Card.Header className="bg-dark text-white" style={{ padding: '0.75rem 1rem' }}>
                          <h5 className="mb-0">
                            <i className="fas fa-database me-2"></i>
                            C3D Metadata
                          </h5>
                        </Card.Header>
                        <Card.Body style={{ padding: '0.75rem 1rem' }}>
                          <div className="row">
                            {Object.entries(this.state.selectedInfoData.c3d_metadata).map(([key, value]) => (
                              <div key={key} className="col-md-6 mb-3">
                                <div className="row">
                                  <div className="col-4">
                                    <label className="form-label fw-bold text-dark">{key}:</label>
                                  </div>
                                  <div className="col-8">
                                    <p className="mb-0">{value || '-'}</p>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                )}

                {/* Photos Section */}
                {this.state.selectedInfoData.photos && this.state.selectedInfoData.photos.length > 0 && (
                  <>
                    <Row className="mb-4">
                      <Col>
                        <h5 className="text-primary">Ảnh</h5>
                        <hr />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <div className="row">
                          {this.state.selectedInfoData.photos.map((photo, index) => (
                            <div key={index} className="col-md-4 mb-3">
                              <div className="card">
                                <img 
                                  src={photo.link} 
                                  alt={photo.description || `Ảnh ${index + 1}`}
                                  className="card-img-top"
                                  style={{ 
                                    height: '200px', 
                                    objectFit: 'cover',
                                    cursor: 'pointer'
                                  }}
                                  onClick={() => this.handlePhotosClick(this.state.selectedInfoData.photos)}
                                  title="Click để xem ảnh lớn"
                                />
                                {photo.description && (
                                  <div className="card-body p-2">
                                    <p className="card-text small mb-0">{photo.description}</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseScanPersonInfoModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Bank Account Info Modal */}
        <Modal show={this.state.showBankAccountInfoModal} onHide={this.handleCloseBankAccountInfoModal} size="xl">
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title>
              <i className="fas fa-university me-2"></i>
              Thông tin Bank Account
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedInfoData && (
              <div>
                <Row>
                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-success text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-info-circle me-2"></i>
                          Thông tin tài khoản
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">MID:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.MID}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Ngân hàng:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.bank_short_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Số tài khoản:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.account_number || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Chi nhánh:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.branch_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Loại:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.type || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Ngày mở:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.open_date ? new Date(this.state.selectedInfoData.open_date).toLocaleDateString('vi-VN') : '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Trạng thái:</label>
                            </div>
                            <div className="col-8">
                              <Badge bg={this.state.selectedInfoData.is_active ? 'success' : 'danger'}>
                                {this.state.selectedInfoData.is_active ? 'Hoạt động' : 'Không hoạt động'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-primary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-user me-2"></i>
                          Thông tin chủ tài khoản
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Trust Person MID:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.trust_person_mid || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Tên đầy đủ:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0 fw-bold">{this.state.selectedInfoData.trusted_person_info?.full_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Tên tiếng Anh:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.trusted_person_info?.full_name_english || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Ghi chú:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.account_note || '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <Card>
                      <Card.Header className="bg-warning text-dark" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-dollar-sign me-2"></i>
                          Phí & Thời gian
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <Row>
                          <Col md="3">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">Phí mở:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.opening_fee ? this.state.selectedInfoData.opening_fee.toLocaleString('vi-VN') + ' VNĐ' : '0 VNĐ'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="3">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">Phí hàng năm:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.annual_fee ? this.state.selectedInfoData.annual_fee.toLocaleString('vi-VN') + ' VNĐ' : '0 VNĐ'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="3">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">Ngày tạo:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.created_at ? new Date(this.state.selectedInfoData.created_at).toLocaleDateString('vi-VN') : '-'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="3">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">Cập nhật:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.updated_at ? new Date(this.state.selectedInfoData.updated_at).toLocaleDateString('vi-VN') : '-'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseBankAccountInfoModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Bank Visa Info Modal */}
        <Modal show={this.state.showBankVisaInfoModal} onHide={this.handleCloseBankVisaInfoModal} size="xl">
          <Modal.Header closeButton className="bg-secondary text-white">
            <Modal.Title>
              <i className="fas fa-credit-card me-2"></i>
              Thông tin Bank Visa
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedInfoData && (
              <div>
                <Row>
                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-secondary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-info-circle me-2"></i>
                          Thông tin thẻ
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-secondary">MID:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.MID}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-secondary">Ngân hàng:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.bank_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-secondary">Số thẻ:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.visa_number || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-secondary">CVVX:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.cvvx || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-secondary">Hạn thẻ:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">
                                {this.state.selectedInfoData.valid_month && this.state.selectedInfoData.valid_year 
                                  ? `${this.state.selectedInfoData.valid_month}/${this.state.selectedInfoData.valid_year}` 
                                  : '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-secondary">Chi nhánh:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.branch_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-secondary">Loại:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.type || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-secondary">Trạng thái:</label>
                            </div>
                            <div className="col-8">
                              <Badge bg={this.state.selectedInfoData.is_active ? 'success' : 'danger'}>
                                {this.state.selectedInfoData.is_active ? 'Hoạt động' : 'Không hoạt động'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-primary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-user me-2"></i>
                          Thông tin chủ thẻ
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Trust Person MID:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.trust_person_mid || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Tên đầy đủ:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0 fw-bold">{this.state.selectedInfoData.trusted_person_info?.full_name || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Tên tiếng Anh:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.trusted_person_info?.full_name_english || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Tài khoản gửi:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.deposit_bank_account_mid || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-primary">Ghi chú:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.account_note || '-'}</p>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <Card>
                      <Card.Header className="bg-warning text-dark" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-dollar-sign me-2"></i>
                          Phí & Thời gian
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <Row>
                          <Col md="3">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">Phí mở:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.opening_fee ? this.state.selectedInfoData.opening_fee.toLocaleString('vi-VN') + ' VNĐ' : '0 VNĐ'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="3">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">Phí hàng năm:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.annual_fee ? this.state.selectedInfoData.annual_fee.toLocaleString('vi-VN') + ' VNĐ' : '0 VNĐ'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="3">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">Ngày tạo:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.created_at ? new Date(this.state.selectedInfoData.created_at).toLocaleDateString('vi-VN') : '-'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="3">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-warning">Cập nhật:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">{this.state.selectedInfoData.updated_at ? new Date(this.state.selectedInfoData.updated_at).toLocaleDateString('vi-VN') : '-'}</p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseBankVisaInfoModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Device Pack Info Modal */}
        <Modal show={this.state.showDevicePackInfoModal} onHide={this.handleCloseDevicePackInfoModal} size="xl">
          <Modal.Header closeButton className="bg-info text-white">
            <Modal.Title>
              <i className="fas fa-location-dot me-2"></i>
              Thông tin Device Pack
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedInfoData && (
              <div>
                <Row>
                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-info text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-info-circle me-2"></i>
                          Thông tin cơ bản
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Serial Number:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.SN || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Location ID:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.location_id || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Network SN:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.NetworkSN || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">PC SN:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0">{this.state.selectedInfoData.PCSN || '-'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Ultraview ID:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center gap-2">
                                <Badge bg="success" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                  {this.state.selectedInfoData.ultraview_id || '-'}
                                </Badge>
                                {this.state.selectedInfoData.ultraview_id && (
                                  <FaCopy 
                                    size={12} 
                                    style={{ cursor: 'pointer', color: '#6c757d' }}
                                    onClick={() => this.copyToClipboard(this.state.selectedInfoData.ultraview_id)}
                                    title="Copy Ultraview ID"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Ultraview Password:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center gap-2">
                                <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                  {this.state.selectedInfoData.ultraview_password || '-'}
                                </Badge>
                                {this.state.selectedInfoData.ultraview_password && (
                                  <FaCopy 
                                    size={12} 
                                    style={{ cursor: 'pointer', color: '#6c757d' }}
                                    onClick={() => this.copyToClipboard(this.state.selectedInfoData.ultraview_password)}
                                    title="Copy Ultraview Password"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">AnyDesk ID:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center gap-2">
                                <Badge bg="secondary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                  {this.state.selectedInfoData.anydesk_id || '-'}
                                </Badge>
                                {this.state.selectedInfoData.anydesk_id && (
                                  <FaCopy 
                                    size={12} 
                                    style={{ cursor: 'pointer', color: '#6c757d' }}
                                    onClick={() => this.copyToClipboard(this.state.selectedInfoData.anydesk_id)}
                                    title="Copy AnyDesk ID"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">AnyDesk Password:</label>
                            </div>
                            <div className="col-8">
                              <div className="d-flex align-items-center gap-2">
                                <Badge bg="secondary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                                  {this.state.selectedInfoData.anydesk_password || '-'}
                                </Badge>
                                {this.state.selectedInfoData.anydesk_password && (
                                  <FaCopy 
                                    size={12} 
                                    style={{ cursor: 'pointer', color: '#6c757d' }}
                                    onClick={() => this.copyToClipboard(this.state.selectedInfoData.anydesk_password)}
                                    title="Copy AnyDesk Password"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-info">Trạng thái:</label>
                            </div>
                            <div className="col-8">
                              <Badge bg={
                                this.state.selectedInfoData.status === 'AVAILABLE' ? 'success' :
                                this.state.selectedInfoData.status === 'IN USE' ? 'warning' :
                                this.state.selectedInfoData.status === 'NOT WORKING' ? 'danger' :
                                this.state.selectedInfoData.status === 'CANCEL' ? 'danger' :
                                'secondary'
                              }>
                                {this.state.selectedInfoData.status === 'AVAILABLE' ? 'Có sẵn' :
                                 this.state.selectedInfoData.status === 'IN USE' ? 'Đang sử dụng' :
                                 this.state.selectedInfoData.status === 'NOT WORKING' ? 'Không hoạt động' :
                                 this.state.selectedInfoData.status === 'CANCEL' ? 'Hủy' :
                                 this.state.selectedInfoData.status || '-'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="h-100">
                      <Card.Header className="bg-success text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-sticky-note me-2"></i>
                          Mô tả & Ghi chú
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Mô tả:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                                {this.state.selectedInfoData.description || '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Ghi chú:</label>
                            </div>
                            <div className="col-8">
                              <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                                {this.state.selectedInfoData.note || '-'}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="row">
                            <div className="col-4">
                              <label className="form-label fw-bold text-success">Đã xóa:</label>
                            </div>
                            <div className="col-8">
                              <Badge bg={this.state.selectedInfoData.is_deleted ? "danger" : "success"}>
                                {this.state.selectedInfoData.is_deleted ? "Đã xóa" : "Hoạt động"}
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <Card>
                      <Card.Header className="bg-secondary text-white" style={{ padding: '0.75rem 1rem' }}>
                        <h5 className="mb-0">
                          <i className="fas fa-clock me-2"></i>
                          Thời gian
                        </h5>
                      </Card.Header>
                      <Card.Body style={{ padding: '0.75rem 1rem' }}>
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-secondary">Ngày tạo:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">
                                    {this.state.selectedInfoData.created_at ? 
                                      new Date(this.state.selectedInfoData.created_at).toLocaleString('vi-VN', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit'
                                      }) : 
                                      '-'
                                    }
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="mb-3">
                              <div className="row">
                                <div className="col-4">
                                  <label className="form-label fw-bold text-secondary">Cập nhật:</label>
                                </div>
                                <div className="col-8">
                                  <p className="mb-0">
                                    {this.state.selectedInfoData.updated_at ? 
                                      new Date(this.state.selectedInfoData.updated_at).toLocaleString('vi-VN', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit'
                                      }) : 
                                      '-'
                                    }
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseDevicePackInfoModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Story Info Modal */}
        <Modal show={this.state.showStoryInfoModal} onHide={this.handleCloseStoryInfoModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-eye me-2"></i>
              Thông tin câu chuyện tin cậy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedInfoData && (
              <div>
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin nghệ sĩ</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1">
                      <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedInfoData.MID || '-'}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Tên nghệ sĩ:</strong> 
                    <div className="mt-1 fw-bold">{this.state.selectedInfoData.artist_name || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Câu chuyện nghệ sĩ:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedInfoData.artist_story || '-'}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin shop Etsy</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Tên shop Etsy:</strong> 
                    <div className="mt-1">{this.state.selectedInfoData.etsy_shop_name || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>Địa điểm:</strong> 
                    <div className="mt-1">{this.state.selectedInfoData.location || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Câu chuyện shop:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedInfoData.etsy_shop_story || '-'}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Mạng xã hội & Tham chiếu</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Website:</strong> 
                    <div className="mt-1">
                      {this.state.selectedInfoData.website ? (
                        <a href={this.state.selectedInfoData.website} target="_blank" rel="noopener noreferrer">
                          <FaExternalLinkAlt size={14} /> {this.state.selectedInfoData.website}
                        </a>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Facebook:</strong> 
                    <div className="mt-1">{this.state.selectedInfoData.facebook_username || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Instagram:</strong> 
                    <div className="mt-1">{this.state.selectedInfoData.instagram_username || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>X (Twitter):</strong> 
                    <div className="mt-1">{this.state.selectedInfoData.x_username || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>YouTube:</strong> 
                    <div className="mt-1">{this.state.selectedInfoData.youtube_channel || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>Ref Etsy Pack MID:</strong> 
                    <div className="mt-1">{this.state.selectedInfoData.ref_etsy_info_pack_mid || '-'}</div>
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Trạng thái & Ghi chú</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={this.state.selectedInfoData.status === 'active' ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.state.selectedInfoData.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Template:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={this.state.selectedInfoData.is_template ? 'info' : 'secondary'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.state.selectedInfoData.is_template ? 'Template' : 'Story'}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Hoạt động:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={this.state.selectedInfoData.is_active ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.state.selectedInfoData.is_active ? 'Có' : 'Không'}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ref Template MID:</strong> 
                    <div className="mt-1">{this.state.selectedInfoData.ref_template_mid || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedInfoData.note || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày tạo:</strong> 
                    <div className="mt-1">
                      {this.state.selectedInfoData.created_at ? 
                        new Date(this.state.selectedInfoData.created_at).toLocaleString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày cập nhật:</strong> 
                    <div className="mt-1">
                      {this.state.selectedInfoData.updated_at ? 
                        new Date(this.state.selectedInfoData.updated_at).toLocaleString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseStoryInfoModal}>
              <i className="fas fa-times me-1"></i>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Setup Etsy Info Modal */}
        <Modal show={this.state.showSetupEtsyInfoModal} onHide={this.handleCloseSetupEtsyInfoModal} size="lg">
          <Modal.Header closeButton className="bg-success text-white">
            <Modal.Title>
              <i className="fas fa-cog me-2"></i>
              Setup Etsy Info - {this.state.selectedEtsyInfoPack?.MID}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedEtsyInfoPack && (
              <div>
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-success">Thông tin cần thiết cho Setup Shop Etsy</h5>
                    <hr />
                  </Col>
                </Row>

                {/* 1. Thông tin AnyDesk */}
                <div className="mb-4">
                  <h6 className="text-primary mb-3">🔑 Thông tin AnyDesk</h6>
                  
                  <Row className="mb-3">
                    <Col md="4">
                      <strong>AnyDesk ID:</strong>
                    </Col>
                    <Col md="8">
                      <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                        <span style={{ flex: 1 }}>
                          {this.state.selectedEtsyInfoPack.device_pack_info?.anydesk_id || '-'}
                        </span>
                        {this.state.selectedEtsyInfoPack.device_pack_info?.anydesk_id && (
                          <FaCopy 
                            size={14} 
                            className="text-muted"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.device_pack_info.anydesk_id)}
                            title="Copy AnyDesk ID"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="4">
                      <strong>AnyDesk Password:</strong>
                    </Col>
                    <Col md="8">
                      <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                        <span style={{ flex: 1 }}>
                          {this.state.selectedEtsyInfoPack.device_pack_info?.anydesk_password || '-'}
                        </span>
                        {this.state.selectedEtsyInfoPack.device_pack_info?.anydesk_password && (
                          <FaCopy 
                            size={14} 
                            className="text-muted"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.device_pack_info.anydesk_password)}
                            title="Copy AnyDesk Password"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>

                <hr className="my-4" />

                {/* 2. Thông tin Setup Shop */}
                <div className="mb-4">
                  <h6 className="text-primary mb-3">📋 Thông tin Setup Shop</h6>

                {/* 1. Etsy Shop Name */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Etsy Shop Name:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {this.state.selectedEtsyInfoPack.trusted_story_info?.etsy_shop_name || '-'}
                      </span>
                      {this.state.selectedEtsyInfoPack.trusted_story_info?.etsy_shop_name && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.trusted_story_info.etsy_shop_name)}
                          title="Copy Etsy Shop Name"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 2. First Name, Last Name */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>First Name, Last Name:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {this.state.selectedEtsyInfoPack.trusted_person_info?.full_name_english || '-'}
                      </span>
                      {this.state.selectedEtsyInfoPack.trusted_person_info?.full_name_english && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.trusted_person_info.full_name_english)}
                          title="Copy Full Name"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 3. Date of Birth */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Date of Birth:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {this.state.selectedEtsyInfoPack.valid_c3d_person_info?.c3d_dob ? this.formatDate(this.state.selectedEtsyInfoPack.valid_c3d_person_info.c3d_dob) : '-'}
                      </span>
                      {this.state.selectedEtsyInfoPack.valid_c3d_person_info?.c3d_dob && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(this.formatDate(this.state.selectedEtsyInfoPack.valid_c3d_person_info.c3d_dob))}
                          title="Copy Date of Birth"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 4. Citizenship ID Number */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Citizenship ID Number:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {this.state.selectedEtsyInfoPack.valid_c3d_number || '-'}
                      </span>
                      {this.state.selectedEtsyInfoPack.valid_c3d_number && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.valid_c3d_number)}
                          title="Copy Citizenship ID"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 5. Taxpayer Address */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Taxpayer Address:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {this.state.selectedEtsyInfoPack.seller_address || '-'}
                      </span>
                      {this.state.selectedEtsyInfoPack.seller_address && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.seller_address)}
                          title="Copy Taxpayer Address"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 6. Phone Number */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Phone Number:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {this.state.selectedEtsyInfoPack.sim_mid || '-'}
                      </span>
                      {this.state.selectedEtsyInfoPack.sim_mid && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.sim_mid)}
                          title="Copy Phone Number"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* 7. Bank Information */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Bank Name:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {(() => {
                          const bankInfo = this.getBankInfoFromBankBrand(this.state.selectedEtsyInfoPack.trusted_bank_account_info?.bank_short_name);
                          return bankInfo ? bankInfo.bank_name : (this.state.selectedEtsyInfoPack.trusted_bank_account_info?.bank_short_name || '-');
                        })()}
                      </span>
                      {this.state.selectedEtsyInfoPack.trusted_bank_account_info?.bank_short_name && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            const bankInfo = this.getBankInfoFromBankBrand(this.state.selectedEtsyInfoPack.trusted_bank_account_info.bank_short_name);
                            this.copyToClipboard(bankInfo ? bankInfo.bank_name : this.state.selectedEtsyInfoPack.trusted_bank_account_info.bank_short_name);
                          }}
                          title="Copy Bank Name"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Bank Name (English):</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {(() => {
                          const bankInfo = this.getBankInfoFromBankBrand(this.state.selectedEtsyInfoPack.trusted_bank_account_info?.bank_short_name);
                          return bankInfo ? bankInfo.english_name : '-';
                        })()}
                      </span>
                      {(() => {
                        const bankInfo = this.getBankInfoFromBankBrand(this.state.selectedEtsyInfoPack.trusted_bank_account_info?.bank_short_name);
                        return bankInfo?.english_name && (
                          <FaCopy 
                            size={14} 
                            className="text-muted"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copyToClipboard(bankInfo.english_name)}
                            title="Copy Bank English Name"
                          />
                        );
                      })()}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Account Number:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {this.state.selectedEtsyInfoPack.trusted_bank_account_info?.account_number || '-'}
                      </span>
                      {this.state.selectedEtsyInfoPack.trusted_bank_account_info?.account_number && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.trusted_bank_account_info.account_number)}
                          title="Copy Account Number"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>SWIFT BIC:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                      <span style={{ flex: 1 }}>
                        {this.getSwiftCodeFromBankBrand(this.state.selectedEtsyInfoPack.trusted_bank_account_info?.bank_short_name) || '-'}
                      </span>
                      {this.getSwiftCodeFromBankBrand(this.state.selectedEtsyInfoPack.trusted_bank_account_info?.bank_short_name) && (
                        <FaCopy 
                          size={14} 
                          className="text-muted"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.copyToClipboard(this.getSwiftCodeFromBankBrand(this.state.selectedEtsyInfoPack.trusted_bank_account_info?.bank_short_name))}
                          title="Copy SWIFT BIC"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                </div>

                <hr className="my-4" />

                {/* 8. Thông tin thẻ Visa */}
                <div className="mb-4">
                  <h6 className="text-primary mb-3">💳 Thông tin thẻ Visa</h6>

                  <Row className="mb-3">
                    <Col md="4">
                      <strong>Số thẻ:</strong>
                    </Col>
                    <Col md="8">
                      <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                        <span style={{ flex: 1 }}>
                          {this.state.selectedEtsyInfoPack.trusted_bank_visa_info?.visa_number || '-'}
                        </span>
                        {this.state.selectedEtsyInfoPack.trusted_bank_visa_info?.visa_number && (
                          <FaCopy 
                            size={14} 
                            className="text-muted"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.trusted_bank_visa_info.visa_number)}
                            title="Copy Số thẻ"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="4">
                      <strong>Tên trên thẻ:</strong>
                    </Col>
                    <Col md="8">
                      <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                        <span style={{ flex: 1 }}>
                          {this.state.selectedEtsyInfoPack.trusted_person_info?.full_name_english || '-'}
                        </span>
                        {this.state.selectedEtsyInfoPack.trusted_person_info?.full_name_english && (
                          <FaCopy 
                            size={14} 
                            className="text-muted"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.trusted_person_info.full_name_english)}
                            title="Copy Tên trên thẻ"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="4">
                      <strong>Hạn thẻ:</strong>
                    </Col>
                    <Col md="8">
                      <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                        <span style={{ flex: 1 }}>
                          {this.state.selectedEtsyInfoPack.trusted_bank_visa_info?.valid_month && this.state.selectedEtsyInfoPack.trusted_bank_visa_info?.valid_year 
                            ? `${this.state.selectedEtsyInfoPack.trusted_bank_visa_info.valid_month.toString().padStart(2, '0')}/${this.state.selectedEtsyInfoPack.trusted_bank_visa_info.valid_year}` 
                            : '-'}
                        </span>
                        {this.state.selectedEtsyInfoPack.trusted_bank_visa_info?.valid_month && this.state.selectedEtsyInfoPack.trusted_bank_visa_info?.valid_year && (
                          <FaCopy 
                            size={14} 
                            className="text-muted"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copyToClipboard(`${this.state.selectedEtsyInfoPack.trusted_bank_visa_info.valid_month.toString().padStart(2, '0')}/${this.state.selectedEtsyInfoPack.trusted_bank_visa_info.valid_year}`)}
                            title="Copy Hạn thẻ"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="4">
                      <strong>CVV:</strong>
                    </Col>
                    <Col md="8">
                      <div className="p-2 bg-light rounded d-flex align-items-center gap-2">
                        <span style={{ flex: 1 }}>
                          {this.state.selectedEtsyInfoPack.trusted_bank_visa_info?.cvvx || '-'}
                        </span>
                        {this.state.selectedEtsyInfoPack.trusted_bank_visa_info?.cvvx && (
                          <FaCopy 
                            size={14} 
                            className="text-muted"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.copyToClipboard(this.state.selectedEtsyInfoPack.trusted_bank_visa_info.cvvx)}
                            title="Copy CVV"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>

                <Row className="mt-4">
                  <Col>
                    <div className="alert alert-info">
                      <i className="fas fa-info-circle me-2"></i>
                      <strong>Lưu ý:</strong> Thông tin này được tổng hợp từ các nguồn dữ liệu liên kết. 
                      Vui lòng kiểm tra và cập nhật nếu cần thiết trước khi sử dụng cho setup shop Etsy.
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseSetupEtsyInfoModal}>
              <i className="fas fa-times me-1"></i>
              Đóng
            </Button>
            <Button variant="success" onClick={() => {
              // Copy all info to clipboard
              const info = this.state.selectedEtsyInfoPack;
              const setupInfo = {
                anydeskId: info.device_pack_info?.anydesk_id || '',
                anydeskPassword: info.device_pack_info?.anydesk_password || '',
                shopName: info.trusted_story_info?.etsy_shop_name || '',
                fullName: info.trusted_person_info?.full_name_english || '',
                dateOfBirth: info.valid_c3d_person_info?.c3d_dob ? this.formatDate(info.valid_c3d_person_info.c3d_dob) : '',
                citizenshipId: info.valid_c3d_number || '',
                taxpayerAddress: info.seller_address || '',
                bankName: (() => {
                  const bankInfo = this.getBankInfoFromBankBrand(info.trusted_bank_account_info?.bank_short_name);
                  return bankInfo ? bankInfo.bank_name : (info.trusted_bank_account_info?.bank_short_name || '');
                })(),
                bankEnglishName: (() => {
                  const bankInfo = this.getBankInfoFromBankBrand(info.trusted_bank_account_info?.bank_short_name);
                  return bankInfo ? bankInfo.english_name : '';
                })(),
                accountNumber: info.trusted_bank_account_info?.account_number || '',
                swiftCode: this.getSwiftCodeFromBankBrand(info.trusted_bank_account_info?.bank_short_name) || '',
                phoneNumber: info.sim_mid || '',
                cardNumber: info.trusted_bank_visa_info?.visa_number || '',
                cardHolderName: info.trusted_person_info?.full_name_english || '',
                expiryDate: info.trusted_bank_visa_info?.valid_month && info.trusted_bank_visa_info?.valid_year 
                  ? `${info.trusted_bank_visa_info.valid_month.toString().padStart(2, '0')}/${info.trusted_bank_visa_info.valid_year}` 
                  : '',
                cvv: info.trusted_bank_visa_info?.cvvx || ''
              };
              
              const text = `Etsy Shop Setup Info:
AnyDesk ID: ${setupInfo.anydeskId}
AnyDesk Password: ${setupInfo.anydeskPassword}
Shop Name: ${setupInfo.shopName}
Full Name: ${setupInfo.fullName}
Date of Birth: ${setupInfo.dateOfBirth}
Citizenship ID: ${setupInfo.citizenshipId}
Taxpayer Address: ${setupInfo.taxpayerAddress}
Phone Number: ${setupInfo.phoneNumber}
Bank Name: ${setupInfo.bankName}
Bank Name (English): ${setupInfo.bankEnglishName}
Account Number: ${setupInfo.accountNumber}
SWIFT BIC: ${setupInfo.swiftCode}
---
Visa Card Information:
Card Number: ${setupInfo.cardNumber}
Card Holder Name: ${setupInfo.cardHolderName}
Expiry Date: ${setupInfo.expiryDate}
CVV: ${setupInfo.cvv}`;
              
              navigator.clipboard.writeText(text);
              this.showToast('Đã copy thông tin setup vào clipboard!', 'success');
            }}>
              <i className="fas fa-copy me-1"></i>
              Copy Info
            </Button>
          </Modal.Footer>
        </Modal>

        {/* SIM Info Modal */}
        <Modal show={this.state.showSimInfoModal} onHide={this.handleCloseSimInfoModal} size="lg">
          <Modal.Header closeButton className="bg-info text-white">
            <Modal.Title>
              <i className="fas fa-mobile-alt me-2"></i>
              Thông tin SIM - {this.state.selectedSimInfo?.number}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedSimInfo && (
              <div>
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-info">Chi tiết thông tin SIM</h5>
                    <hr />
                  </Col>
                </Row>

                {/* Basic Info */}
                <Row className="mb-3">
                  <Col md="4">
                    <strong>Số điện thoại:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-info text-white rounded d-flex align-items-center gap-2">
                      <Badge bg="light" text="dark" style={{ fontSize: '1em', padding: '8px 12px' }}>
                        {this.state.selectedSimInfo.number}
                      </Badge>
                      <FaCopy 
                        size={14} 
                        style={{ cursor: 'pointer', color: '#ffffff' }}
                        onClick={() => navigator.clipboard.writeText(this.state.selectedSimInfo.number)}
                        title="Copy số điện thoại"
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Nhà mạng:</strong>
                  </Col>
                  <Col md="8">
                    <Badge bg="primary" style={{ fontSize: '1em', padding: '8px 12px' }}>
                      {this.state.selectedSimInfo.mobile_network_provider || '-'}
                    </Badge>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Trạng thái:</strong>
                  </Col>
                  <Col md="8">
                    <Badge 
                      bg={this.state.selectedSimInfo.status === 'ACTIVE' ? 'success' : 'danger'} 
                      style={{ fontSize: '1em', padding: '8px 12px' }}
                    >
                      {this.state.selectedSimInfo.status || '-'}
                    </Badge>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Phí setup:</strong>
                  </Col>
                  <Col md="8">
                    <span className="fw-bold text-success">
                      {this.state.selectedSimInfo.setup_fee ? 
                        new Intl.NumberFormat('vi-VN', { 
                          style: 'currency', 
                          currency: 'VND' 
                        }).format(this.state.selectedSimInfo.setup_fee) : '-'}
                    </span>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Phí hàng tháng:</strong>
                  </Col>
                  <Col md="8">
                    <span className="fw-bold text-warning">
                      {this.state.selectedSimInfo.monthly_fee ? 
                        new Intl.NumberFormat('vi-VN', { 
                          style: 'currency', 
                          currency: 'VND' 
                        }).format(this.state.selectedSimInfo.monthly_fee) : '-'}
                    </span>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Ngày đăng ký:</strong>
                  </Col>
                  <Col md="8">
                    <span>
                      {this.state.selectedSimInfo.registered_date ? 
                        new Date(this.state.selectedSimInfo.registered_date).toLocaleDateString('vi-VN') : '-'}
                    </span>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Ghi chú:</strong>
                  </Col>
                  <Col md="8">
                    <div className="p-2 bg-light rounded">
                      {this.state.selectedSimInfo.note || '-'}
                    </div>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Etsy Info Pack MID:</strong>
                  </Col>
                  <Col md="8">
                    {this.state.selectedSimInfo.ref_etsy_info_pack_mid ? (
                      <Badge bg="success" style={{ fontSize: '1em', padding: '8px 12px' }}>
                        {this.state.selectedSimInfo.ref_etsy_info_pack_mid}
                      </Badge>
                    ) : (
                      <span className="text-muted">Chưa được gán</span>
                    )}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Hoạt động:</strong>
                  </Col>
                  <Col md="8">
                    <Badge 
                      bg={this.state.selectedSimInfo.is_active ? 'success' : 'danger'} 
                      style={{ fontSize: '1em', padding: '8px 12px' }}
                    >
                      {this.state.selectedSimInfo.is_active ? 'Có' : 'Không'}
                    </Badge>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Ngày tạo:</strong>
                  </Col>
                  <Col md="8">
                    <span>
                      {this.state.selectedSimInfo.created_at ? 
                        new Date(this.state.selectedSimInfo.created_at).toLocaleString('vi-VN') : '-'}
                    </span>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="4">
                    <strong>Ngày cập nhật:</strong>
                  </Col>
                  <Col md="8">
                    <span>
                      {this.state.selectedSimInfo.updated_at ? 
                        new Date(this.state.selectedSimInfo.updated_at).toLocaleString('vi-VN') : '-'}
                    </span>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseSimInfoModal}>
              <i className="fas fa-times me-1"></i>
              Đóng
            </Button>
            <Button variant="info" onClick={() => {
              // Copy SIM info to clipboard
              const sim = this.state.selectedSimInfo;
              const text = `SIM Info:
Số điện thoại: ${sim.number}
Nhà mạng: ${sim.mobile_network_provider}
Trạng thái: ${sim.status}
Phí setup: ${sim.setup_fee ? new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(sim.setup_fee) : '-'}
Phí hàng tháng: ${sim.monthly_fee ? new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(sim.monthly_fee) : '-'}
Ngày đăng ký: ${sim.registered_date ? new Date(sim.registered_date).toLocaleDateString('vi-VN') : '-'}
Ghi chú: ${sim.note || '-'}
Etsy Info Pack MID: ${sim.ref_etsy_info_pack_mid || 'Chưa được gán'}`;
              
              navigator.clipboard.writeText(text);
              this.showToast('Đã copy thông tin SIM vào clipboard!', 'success');
            }}>
              <i className="fas fa-copy me-1"></i>
              Copy Info
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={this.handleCloseConfigModal}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    mid: 'MID',
                    trusted_person_mid: 'Trusted Person MID',
                    valid_c3d_number: 'Valid C3D Number',
                    scan_person_mid: 'Scan Person MID',
                    trusted_bank_acc_mid: 'Trusted Bank Account MID',
                    trusted_bank_visa_mid: 'Trusted Bank Visa MID',
                    device_pack_location_id: 'Device Pack Location ID',
                    trusted_story_mid: 'Trusted Story MID',
                    shop_name: 'Shop Name',
                    seller_name: 'Seller Name',
                    sim_mid: 'Số SIM / Số điện thoại',
                    seller_address: 'Địa chỉ người bán',
                    email1_mid: 'Email 1 MID',
                    email2_mid: 'Email 2 MID',
                    buyer_registration_date: 'Buyer Registration Date',
                    seller_registration_date: 'Seller Registration Date',
                    note: 'Ghi chú',
                    status: 'Trạng thái',
                    is_active: 'Hoạt động',
                    created_at: 'Ngày tạo'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseConfigModal}>
              Đóng
            </Button>
            <Button variant="primary" onClick={this.handleSaveConfig}>
              Lưu cấu hình
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Note Modal */}
        <Modal show={this.state.showNoteModal} onHide={this.handleCloseNoteModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-sticky-note me-2"></i>
              Ghi chú chi tiết
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedNoteData && (
              <div>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNoteData.MID}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Trusted Person MID:</strong> 
                    <div className="mt-1">
                      <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNoteData.trusted_person_mid}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>C3D Number:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNoteData.valid_c3d_number || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-2 p-3 bg-light rounded" style={{ 
                      whiteSpace: 'pre-wrap',
                      maxHeight: '400px',
                      overflowY: 'auto',
                      border: '1px solid #dee2e6'
                    }}>
                      {this.state.selectedNoteData.note || 'Không có ghi chú'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseNoteModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Toast Notification */}
        <ToastContainer 
          position="top-end" 
          className="p-3"
          style={{ 
            position: 'fixed', 
            top: '20px', 
            right: '20px', 
            zIndex: 9999 
          }}
        >
          <Toast 
            show={this.state.showToast} 
            onClose={() => this.setState({ showToast: false })}
            bg={this.state.toastType === 'success' ? 'success' : 'danger'}
            autohide
            delay={3000}
          >
            <Toast.Header>
              <i className={`fas fa-${this.state.toastType === 'success' ? 'check-circle' : 'exclamation-triangle'} me-2`}></i>
              <strong className="me-auto">
                {this.state.toastType === 'success' ? 'Thành công' : 'Lỗi'}
              </strong>
            </Toast.Header>
            <Toast.Body className="text-white">
              {this.state.toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />

        {/* Photos Modal */}
        <Modal show={this.state.showPhotosModal} onHide={this.handleClosePhotosModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-images me-2"></i>
              Xem ảnh ({this.state.currentPhotoIndex + 1}/{this.state.selectedPhotos.length})
            </Modal.Title>
          </Modal.Header>
          {this.state.selectedPhotos.length > 1 && (
            <div className="text-center text-muted small mb-2" style={{ backgroundColor: '#f8f9fa', padding: '8px' }}>
              <i className="fas fa-keyboard me-1"></i>
              Sử dụng phím mũi tên ← → để chuyển ảnh, ESC để đóng
            </div>
          )}
          <Modal.Body>
            {this.state.selectedPhotos.length > 0 ? (
              <div className="text-center">
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img 
                    src={this.state.selectedPhotos[this.state.currentPhotoIndex].link} 
                    alt={this.state.selectedPhotos[this.state.currentPhotoIndex].description || `Ảnh ${this.state.currentPhotoIndex + 1}`}
                    style={{ 
                      maxWidth: '100%', 
                      maxHeight: '70vh', 
                      objectFit: 'contain',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                    }}
                  />
                  
                  {/* Navigation arrows */}
                  {this.state.selectedPhotos.length > 1 && (
                    <>
                      <Button
                        variant="light"
                        style={{
                          position: 'absolute',
                          left: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          borderRadius: '50%',
                          width: '50px',
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '0',
                          border: '2px solid rgba(0,0,0,0.1)',
                          backgroundColor: 'rgba(255,255,255,0.9)',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                          zIndex: 10
                        }}
                        onClick={this.handlePrevPhoto}
                        title="Ảnh trước (←)"
                      >
                        <FaChevronLeft size={16} color="#333" />
                      </Button>
                      
                      <Button
                        variant="light"
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          borderRadius: '50%',
                          width: '50px',
                          height: '50px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '0',
                          border: '2px solid rgba(0,0,0,0.1)',
                          backgroundColor: 'rgba(255,255,255,0.9)',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                          zIndex: 10
                        }}
                        onClick={this.handleNextPhoto}
                        title="Ảnh tiếp theo (→)"
                      >
                        <FaChevronRight size={16} color="#333" />
                      </Button>
                    </>
                  )}
                </div>
                
                {/* Photo description */}
                {this.state.selectedPhotos[this.state.currentPhotoIndex].description && (
                  <div className="mt-3">
                    <p className="text-muted mb-0">
                      {this.state.selectedPhotos[this.state.currentPhotoIndex].description}
                    </p>
                  </div>
                )}
                
                {/* Action buttons */}
                <div className="mt-3 d-flex justify-content-center gap-2">
                  <Button
                    variant="primary"
                    onClick={() => window.open(this.state.selectedPhotos[this.state.currentPhotoIndex].link, '_blank')}
                  >
                    <i className="fas fa-external-link-alt me-1"></i>
                    Mở trong tab mới
                  </Button>
                  <Button
                    variant="success"
                    onClick={() => this.handleDownloadImage(
                      this.state.selectedPhotos[this.state.currentPhotoIndex].link, 
                      `photo_${this.state.currentPhotoIndex + 1}.jpg`
                    )}
                  >
                    <i className="fas fa-download me-1"></i>
                    Tải xuống
                  </Button>
                </div>
              </div>
            ) : (
              <div className="text-center text-muted">
                <i className="fas fa-images fa-3x mb-3"></i>
                <p>Không có ảnh để hiển thị</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClosePhotosModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Email 1 Info Modal */}
        <Modal show={this.state.showEmail1InfoModal} onHide={this.handleCloseEmail1InfoModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-envelope me-2"></i>
              Thông tin Email 1
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedEmailInfo && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedEmailInfo.MID}
                      </Badge>
                      <FaCopy 
                        size={14} 
                        style={{ cursor: 'pointer', color: '#6c757d' }}
                        onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.MID)}
                        title="Copy MID"
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Email:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedEmailInfo.email}
                      </Badge>
                      <FaCopy 
                        size={14} 
                        style={{ cursor: 'pointer', color: '#6c757d' }}
                        onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.email)}
                        title="Copy Email"
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Tên:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmailInfo.name || '-'}</span>
                      {this.state.selectedEmailInfo.name && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.name)}
                          title="Copy Name"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Quốc gia:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmailInfo.country || '-'}</span>
                      {this.state.selectedEmailInfo.country && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.country)}
                          title="Copy Country"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                
                {/* Security Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin bảo mật</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Mật khẩu:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedEmailInfo.password || '-'}
                      </Badge>
                      {this.state.selectedEmailInfo.password && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.password)}
                          title="Copy Password"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Email khôi phục:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmailInfo.recovery_email || '-'}</span>
                      {this.state.selectedEmailInfo.recovery_email && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.recovery_email)}
                          title="Copy Recovery Email"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Mã 2FA:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmailInfo.code_2fa || '-'}</span>
                      {this.state.selectedEmailInfo.code_2fa && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.code_2fa)}
                          title="Copy 2FA Code"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Số điện thoại:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmailInfo.phone || '-'}</span>
                      {this.state.selectedEmailInfo.phone && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.phone)}
                          title="Copy Phone"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* Avatar */}
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Avatar:</strong> 
                    <div className="mt-2">
                      {this.state.selectedEmailInfo.avatar ? (
                        <img 
                          src={this.state.selectedEmailInfo.avatar} 
                          alt="Avatar"
                          style={{ 
                            width: '100px', 
                            height: '100px', 
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: '2px solid #dee2e6'
                          }}
                        />
                      ) : (
                        <div 
                          style={{ 
                            width: '100px', 
                            height: '100px', 
                            backgroundColor: '#f8f9fa',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px solid #dee2e6'
                          }}
                        >
                          <i className="fas fa-user fa-2x text-muted"></i>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                
                {/* Financial Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin tài chính</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Giá:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmailInfo.price ? (
                        <span className="text-success fw-bold">
                          {this.state.selectedEmailInfo.price.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày mua:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmailInfo.purchase_date ? 
                        new Date(this.state.selectedEmailInfo.purchase_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                
                {/* Etsy Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin Etsy</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày đăng ký Etsy:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmailInfo.etsy_register_date ? 
                        new Date(this.state.selectedEmailInfo.etsy_register_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={this.state.selectedEmailInfo.status === 'ACTIVE' ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.state.selectedEmailInfo.status === 'ACTIVE' ? 'Hoạt động' : 'Không hoạt động'}
                      </Badge>
                    </div>
                  </Col>
                </Row>

                {/* Note */}
                {this.state.selectedEmailInfo.note && (
                  <Row className="mb-3">
                    <Col md="12">
                      <strong>Ghi chú:</strong> 
                      <div className="mt-1">
                        {this.state.selectedEmailInfo.note}
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEmail1InfoModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Email 2 Info Modal */}
        <Modal show={this.state.showEmail2InfoModal} onHide={this.handleCloseEmail2InfoModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-envelope me-2"></i>
              Thông tin Email 2
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedEmailInfo && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedEmailInfo.MID}
                      </Badge>
                      <FaCopy 
                        size={14} 
                        style={{ cursor: 'pointer', color: '#6c757d' }}
                        onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.MID)}
                        title="Copy MID"
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Email:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedEmailInfo.email}
                      </Badge>
                      <FaCopy 
                        size={14} 
                        style={{ cursor: 'pointer', color: '#6c757d' }}
                        onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.email)}
                        title="Copy Email"
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Tên:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmailInfo.name || '-'}</span>
                      {this.state.selectedEmailInfo.name && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.name)}
                          title="Copy Name"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Quốc gia:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmailInfo.country || '-'}</span>
                      {this.state.selectedEmailInfo.country && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.country)}
                          title="Copy Country"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                
                {/* Security Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin bảo mật</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Mật khẩu:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedEmailInfo.password || '-'}
                      </Badge>
                      {this.state.selectedEmailInfo.password && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.password)}
                          title="Copy Password"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Email khôi phục:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmailInfo.recovery_email || '-'}</span>
                      {this.state.selectedEmailInfo.recovery_email && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.recovery_email)}
                          title="Copy Recovery Email"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Mã 2FA:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmailInfo.code_2fa || '-'}</span>
                      {this.state.selectedEmailInfo.code_2fa && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.code_2fa)}
                          title="Copy 2FA Code"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Số điện thoại:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmailInfo.phone || '-'}</span>
                      {this.state.selectedEmailInfo.phone && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => navigator.clipboard.writeText(this.state.selectedEmailInfo.phone)}
                          title="Copy Phone"
                        />
                      )}
                    </div>
                  </Col>
                </Row>

                {/* Avatar */}
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Avatar:</strong> 
                    <div className="mt-2">
                      {this.state.selectedEmailInfo.avatar ? (
                        <img 
                          src={this.state.selectedEmailInfo.avatar} 
                          alt="Avatar"
                          style={{ 
                            width: '100px', 
                            height: '100px', 
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: '2px solid #dee2e6'
                          }}
                        />
                      ) : (
                        <div 
                          style={{ 
                            width: '100px', 
                            height: '100px', 
                            backgroundColor: '#f8f9fa',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px solid #dee2e6'
                          }}
                        >
                          <i className="fas fa-user fa-2x text-muted"></i>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                
                {/* Financial Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin tài chính</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Giá:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmailInfo.price ? (
                        <span className="text-success fw-bold">
                          {this.state.selectedEmailInfo.price.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày mua:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmailInfo.purchase_date ? 
                        new Date(this.state.selectedEmailInfo.purchase_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                
                {/* Etsy Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin Etsy</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày đăng ký Etsy:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmailInfo.etsy_register_date ? 
                        new Date(this.state.selectedEmailInfo.etsy_register_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      <Badge 
                        bg={this.state.selectedEmailInfo.status === 'ACTIVE' ? 'success' : 'danger'} 
                        style={{ fontSize: '0.8em', padding: '4px 8px' }}
                      >
                        {this.state.selectedEmailInfo.status === 'ACTIVE' ? 'Hoạt động' : 'Không hoạt động'}
                      </Badge>
                    </div>
                  </Col>
                </Row>

                {/* Note */}
                {this.state.selectedEmailInfo.note && (
                  <Row className="mb-3">
                    <Col md="12">
                      <strong>Ghi chú:</strong> 
                      <div className="mt-1">
                        {this.state.selectedEmailInfo.note}
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEmail2InfoModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    etsyInfoPacks: state.tkt1EtsyInfoPackReducer?.etsyInfoPacks || [],
    totalCount: state.tkt1EtsyInfoPackReducer?.totalCount || 0,
    currentEtsyInfoPack: state.tkt1EtsyInfoPackReducer?.currentEtsyInfoPack,
    loading: state.tkt1EtsyInfoPackReducer?.loading || false,
    error: state.tkt1EtsyInfoPackReducer?.error,
    bankBrands: state.tkt1BankBrandReducer?.bankBrands || [],
    trustedPersonInfos: state.tkt1TrustedPersonReducer?.trustedPersonInfos || [],
    c3dInfos: state.tkt1C3DInfoReducer?.c3dInfos || [],
    scanPersons: state.tkt1ScanPersonReducer?.scanPersons || [],
    trustedBankAccounts: state.tkt1TrustedBankAccountReducer?.trustedBankAccounts || [],
    trustedBankVisas: state.tkt1TrustedBankVisaReducer?.trustedBankVisas || [],
    devicePacks: state.tkt1DevicePackReducer?.devicePacks || [],
    trustedStories: state.tkt1TrustedStoryReducer?.trustedStories || [],
    sims: state.tkt1SimReducer?.sims || [],
    emails: state.tkt1EmailReducer?.emails || []
  };
};

export default connect(mapStateToProps, { 
  getTKT1EtsyInfoPacks,
  updateTKT1EtsyInfoPack,
  createTKT1EtsyInfoPack,
  getTKT1BankBrands,
  getTKT1TrustedPersonInfos,
  getTKT1C3DInfos,
  getTKT1ScanPersons,
  getTKT1TrustedBankAccounts,
  getTKT1TrustedBankVisas,
  getTKT1DevicePacks,
  getTKT1TrustedStories,
  getTKT1Sims,
  getTKT1Emails
})(TKT1EtsyInfoPack);
